// -- (function(scope){
// -- 'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.a8.as === region.bC.as)
	{
		return 'on line ' + region.a8.as;
	}
	return 'on lines ' + region.a8.as + ' through ' + region.bC.as;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.bV,
		impl.cR,
		impl.cN,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


/*
function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/


/*
function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		dl: func(record.dl),
		dC: record.dC,
		ds: record.ds
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.dl;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.dC;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.ds) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.bV,
		impl.cR,
		impl.cN,
		function(sendToApp, initialModel) {
			var view = impl.cV;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.bV,
		impl.cR,
		impl.cN,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.a6 && impl.a6(sendToApp)
			var view = impl.cV;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.x);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.aJ) && (_VirtualDom_doc.title = title = doc.aJ);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.$7;
	var onUrlRequest = impl.dp;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		a6: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.cr === next.cr
							&& curr.bO === next.bO
							&& curr.ci.a === next.ci.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		bV: function(flags)
		{
			return A3(impl.bV, flags, _Browser_getUrl(), key);
		},
		cV: impl.cV,
		cR: impl.cR,
		cN: impl.cN
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { dd: 'hidden', c5: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { dd: 'mozHidden', c5: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { dd: 'msHidden', c5: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { dd: 'webkitHidden', c5: 'webkitvisibilitychange' }
		: { dd: 'hidden', c5: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		cD: _Browser_getScene(),
		cW: {
			c$: _Browser_window.pageXOffset,
			c0: _Browser_window.pageYOffset,
			bd: _Browser_doc.documentElement.clientWidth,
			bM: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		bd: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		bM: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			cD: {
				bd: node.scrollWidth,
				bM: node.scrollHeight
			},
			cW: {
				c$: node.scrollLeft,
				c0: node.scrollTop,
				bd: node.clientWidth,
				bM: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			cD: _Browser_getScene(),
			cW: {
				c$: x,
				c0: y,
				bd: _Browser_doc.documentElement.clientWidth,
				bM: _Browser_doc.documentElement.clientHeight
			},
			ag: {
				c$: x + rect.left,
				c0: y + rect.top,
				bd: rect.width,
				bM: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.s.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.s.b, xhr)); });
		$elm$core$Maybe$isJust(request.ax) && _Http_track(router, xhr, request.ax.a);

		try {
			xhr.open(request.at, request.w, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.w));
		}

		_Http_configureRequest(xhr, request);

		request.x.a && xhr.setRequestHeader('Content-Type', request.x.a);
		xhr.send(request.x.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.ar; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.av.a || 0;
	xhr.responseType = request.s.d;
	xhr.withCredentials = request.c2;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		w: xhr.responseURL,
		cL: xhr.status,
		dB: xhr.statusText,
		ar: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			dA: event.loaded,
			a7: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			du: event.loaded,
			a7: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.a$) { flags += 'm'; }
	if (options.aL) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});
var $author$project$Page$Agents$New$Flags = function (tenant) {
	return {o: tenant};
};
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $author$project$Pwr$Tenant$Internals = function (shortName) {
	return function (tenant_) {
		return function (merchantGroupId) {
			return function (projectWorksheetIdRequired) {
				return function (projectWorksheetIdDisplayed) {
					return function (eligibleForMultipleReviewTypes) {
						return function (salonCentricCommunityDisplayed) {
							return function (featDtrCollection) {
								return function (featIgCollection) {
									return function (communityClosed) {
										return function (dateFormat) {
											return {bq: communityClosed, bt: dateFormat, bA: eligibleForMultipleReviewTypes, bG: featDtrCollection, bH: featIgCollection, b3: merchantGroupId, cp: projectWorksheetIdDisplayed, cq: projectWorksheetIdRequired, cB: salonCentricCommunityDisplayed, cJ: shortName, aI: tenant_};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $author$project$Pwr$Tenant$Tenant = $elm$core$Basics$identity;
var $author$project$Pwr$DateFormat$US = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.h) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.i),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.i);
		} else {
			var treeLen = builder.h * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.j) : builder.j;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.h);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.i) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.i);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{j: nodeList, h: (len / $elm$core$Array$branchFactor) | 0, i: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Pwr$DateFormat$European = 1;
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $author$project$Pwr$DateFormat$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		if (value === 'european') {
			return $elm$json$Json$Decode$succeed(1);
		} else {
			return $elm$json$Json$Decode$succeed(0);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$json$Json$Decode$map2 = _Json_map2;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Pwr$Tenant$Bzz = 0;
var $author$project$Pwr$Tenant$DemoStore = 3;
var $author$project$Pwr$Tenant$Jlp = 1;
var $author$project$Pwr$Tenant$Salon = 2;
var $author$project$Pwr$Tenant$Samsung = 4;
var $author$project$Pwr$Tenant$tenant_Decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (id) {
		switch (id) {
			case 1:
				return $elm$json$Json$Decode$succeed(0);
			case 2:
				return $elm$json$Json$Decode$succeed(2);
			case 3:
				return $elm$json$Json$Decode$succeed(1);
			case 4:
				return $elm$json$Json$Decode$succeed(3);
			case 5:
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Expected value of 1, 2, 3, 4, or 5 for Tenant ID');
		}
	},
	$elm$json$Json$Decode$int);
var $author$project$Pwr$Tenant$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'dateFormat',
		$author$project$Pwr$DateFormat$decoder,
		0,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'communityClosed',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'featIgCollection',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'featDtrCollection',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'salonCentricCommunityDisplayed',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'eligibleForMultipleReviewTypes',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'projectWorksheetIdDisplayed',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'projectWorksheetIdRequired',
									$elm$json$Json$Decode$bool,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'merchantGroupId',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$author$project$Pwr$Tenant$tenant_Decoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'shortName',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Pwr$Tenant$Internals)))))))))))));
var $author$project$Page$Agents$New$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'currentTenant',
	$author$project$Pwr$Tenant$decoder,
	$elm$json$Json$Decode$succeed($author$project$Page$Agents$New$Flags));
var $author$project$Page$Agents$AccountAccess$CreateAccount = 0;
var $author$project$Page$Agents$AccountAccess$ConfirmationEmailSent = 1;
var $author$project$Page$Agents$AccountAccess$EmailMissing = 3;
var $author$project$Page$Agents$AccountAccess$LoginEmailSent = 2;
var $author$project$Page$Agents$AccountAccess$RequestLoginLink = 4;
var $author$project$Pwr$Tenant$communityClosed = function (_v0) {
	var tenant = _v0;
	return tenant.bq;
};
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $erlandsona$assoc_set$AssocSet$Set = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$D = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$empty = _List_Nil;
var $erlandsona$assoc_set$AssocSet$empty = $pzp1997$assoc_list$AssocList$empty;
var $author$project$Page$Agents$AccountAccess$emptyForm = {B: '', J: '', ai: false, M: ''};
var $author$project$SelectList$SelectList = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$SelectList$fromLists = $author$project$SelectList$SelectList;
var $author$project$Page$Agents$AccountAccess$init = F2(
	function (page, tenant) {
		var signupPages = $author$project$Pwr$Tenant$communityClosed(tenant) ? _List_Nil : _List_fromArray(
			[0, 1]);
		var loginPages = _List_fromArray(
			[4, 2, 3]);
		var loadedPage = A3(
			$author$project$SelectList$fromLists,
			_List_Nil,
			page,
			$elm$core$List$concat(
				_List_fromArray(
					[loginPages, signupPages])));
		return {g: $erlandsona$assoc_set$AssocSet$empty, l: $author$project$Page$Agents$AccountAccess$emptyForm, C: '', N: $erlandsona$assoc_set$AssocSet$empty, f: loadedPage, W: false, v: false, Y: false, _: false, o: tenant};
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Page$Agents$New$init = function (flags) {
	return _Utils_Tuple2(
		A2($author$project$Page$Agents$AccountAccess$init, 0, flags.o),
		$elm$core$Platform$Cmd$none);
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Page$Internal = F2(
	function (notifications, model) {
		return {aE: model, b9: notifications};
	});
var $author$project$Page$PageMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Running = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$StartupFailure = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {bK: fragment, bO: host, ce: path, ci: port_, cr: protocol, cs: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $author$project$Notification$Notification = F2(
	function (severity, message) {
		return {dl: message, k: severity};
	});
var $author$project$Notification$Alert = 5;
var $author$project$Notification$Error = 4;
var $author$project$Notification$Info = 0;
var $author$project$Notification$Notice = 1;
var $author$project$Notification$Success = 3;
var $author$project$Notification$Warning = 2;
var $author$project$Notification$severityDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'info':
				return $elm$json$Json$Decode$succeed(0);
			case 'notice':
				return $elm$json$Json$Decode$succeed(1);
			case 'warning':
				return $elm$json$Json$Decode$succeed(2);
			case 'success':
				return $elm$json$Json$Decode$succeed(3);
			case 'error':
				return $elm$json$Json$Decode$succeed(4);
			case 'alert':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$fail('Severity must be one of: Info, Notice, Warning, Success, Error, Alert');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Notification$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'message',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'severity',
		$author$project$Notification$severityDecoder,
		$elm$json$Json$Decode$succeed($author$project$Notification$Notification)));
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Page$notificationsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Notification$decoder),
					$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
				]))));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Page$flagsDecoder = function (decoder) {
	return A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		decoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'initialNotifications',
			$author$project$Page$notificationsDecoder,
			_List_Nil,
			$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)));
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Page$NoOp = {$: 3};
var $author$project$Page$GotNotification = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$inboundDecoder = function (_v0) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (tag) {
			if (tag === 'GotNotification') {
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Page$GotNotification,
					A2($elm$json$Json$Decode$field, 'notification', $author$project$Notification$decoder));
			} else {
				return $elm$json$Json$Decode$succeed($author$project$Page$NoOp);
			}
		},
		A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
};
var $author$project$Page$pageInbound = _Platform_incomingPort('pageInbound', $elm$json$Json$Decode$value);
var $author$project$Page$inbound = function (model) {
	return $author$project$Page$pageInbound(
		function (value) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				$author$project$Page$inboundDecoder(model),
				value);
			if (!_v0.$) {
				var msg = _v0.a;
				return msg;
			} else {
				return $author$project$Page$NoOp;
			}
		});
};
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$Page$wrapSubscriptions = F2(
	function (subscriptions, outerModel) {
		if (outerModel.$ === 1) {
			return $elm$core$Platform$Sub$none;
		} else {
			var model = outerModel.a.aE;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$Page$PageMsg,
						subscriptions(model)),
						$author$project$Page$inbound(outerModel)
					]));
		}
	});
var $author$project$Notification$eq = F2(
	function (left, right) {
		return _Utils_eq(left, right);
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Basics$not = _Basics_not;
var $author$project$Page$wrapUpdate = F3(
	function (update, outerMsg, outerModel) {
		if (outerModel.$ === 1) {
			return _Utils_Tuple2(outerModel, $elm$core$Platform$Cmd$none);
		} else {
			var internal = outerModel.a;
			var notifications = internal.b9;
			var model = internal.aE;
			switch (outerMsg.$) {
				case 3:
					return _Utils_Tuple2(outerModel, $elm$core$Platform$Cmd$none);
				case 0:
					var msg = outerMsg.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Page$Running,
							$author$project$Page$Internal(notifications)),
						$elm$core$Platform$Cmd$map($author$project$Page$PageMsg),
						A2(update, msg, model));
				case 2:
					var notification = outerMsg.a;
					return _Utils_Tuple2(
						$author$project$Page$Running(
							_Utils_update(
								internal,
								{
									b9: A2($elm$core$List$cons, notification, notifications)
								})),
						$elm$core$Platform$Cmd$none);
				default:
					var notification = outerMsg.a;
					return _Utils_Tuple2(
						$author$project$Page$Running(
							_Utils_update(
								internal,
								{
									b9: A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeL,
											$elm$core$Basics$not,
											$author$project$Notification$eq(notification)),
										notifications)
								})),
						$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Page$ClickedDismissNotification = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Html$Extra$none = $elm$html$Html$text('');
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$core$String$cons = _String_cons;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$Char$toLower = _Char_toLower;
var $author$project$String$Extra$dasherize = A2(
	$elm$core$String$foldr,
	F2(
		function (_char, result) {
			return ($elm$core$Char$isAlphaNum(_char) || (_char === '-')) ? A2(
				$elm$core$String$cons,
				$elm$core$Char$toLower(_char),
				result) : ((_char === ' ') ? A2($elm$core$String$cons, '-', result) : result);
		}),
	'');
var $author$project$Pwr$Test$attribute = A2(
	$elm$core$Basics$composeL,
	$elm$html$Html$Attributes$attribute('data-testid'),
	$author$project$String$Extra$dasherize);
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Pwr$Ui$Icon$Twenty = function (a) {
	return {$: 0, a: a};
};
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $author$project$Pwr$Ui$Icon$cancel = $author$project$Pwr$Ui$Icon$Twenty(
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M11.414 10l4.293-4.293a.999.999 0 10-1.414-1.414L10 8.586 5.707 4.293a.999.999 0 10-1.414 1.414L8.586 10l-4.293 4.293a.999.999 0 101.414 1.414L10 11.414l4.293 4.293a.997.997 0 001.414 0 .999.999 0 000-1.414L11.414 10z')
				]),
			_List_Nil)
		]));
var $author$project$Pwr$Ui$Icon$TwentyFour = function (a) {
	return {$: 1, a: a};
};
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $author$project$Pwr$Ui$Icon$check = $author$project$Pwr$Ui$Icon$TwentyFour(
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z')
				]),
			_List_Nil)
		]));
var $author$project$Pwr$Ui$Icon$Attribute = $elm$core$Basics$identity;
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $author$project$Pwr$Ui$Icon$class = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $elm$svg$Svg$Attributes$class);
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$Pwr$Ui$Icon$classList = function (classes) {
	return $author$project$Pwr$Ui$Icon$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$Pwr$Ui$Icon$error = $author$project$Pwr$Ui$Icon$TwentyFour(
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z')
				]),
			_List_Nil)
		]));
var $author$project$Pwr$Ui$Icon$info = $author$project$Pwr$Ui$Icon$TwentyFour(
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z')
				]),
			_List_Nil)
		]));
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $author$project$Pwr$Ui$Icon$unattr = function (_v0) {
	var attr = _v0;
	return attr;
};
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $author$project$Pwr$Ui$Icon$view = F2(
	function (attrs, icon) {
		switch (icon.$) {
			case 0:
				var inner = icon.a;
				return A2(
					$elm$svg$Svg$svg,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
									$elm$svg$Svg$Attributes$fill('currentColor'),
									$elm$svg$Svg$Attributes$stroke('none')
								]),
								A2($elm$core$List$map, $author$project$Pwr$Ui$Icon$unattr, attrs)
							])),
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($elm$core$Basics$never),
						inner));
			case 1:
				var inner = icon.a;
				return A2(
					$elm$svg$Svg$svg,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
									$elm$svg$Svg$Attributes$fill('currentColor'),
									$elm$svg$Svg$Attributes$stroke('none')
								]),
								A2($elm$core$List$map, $author$project$Pwr$Ui$Icon$unattr, attrs)
							])),
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($elm$core$Basics$never),
						inner));
			default:
				var inner = icon.a;
				return A2(
					$elm$svg$Svg$svg,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
									$elm$svg$Svg$Attributes$fill('currentColor'),
									$elm$svg$Svg$Attributes$stroke('none')
								]),
								A2($elm$core$List$map, $author$project$Pwr$Ui$Icon$unattr, attrs)
							])),
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($elm$core$Basics$never),
						inner));
		}
	});
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Notification$viewMessage = function (message) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$author$project$Pwr$Test$attribute('notification-text'),
				$elm$html$Html$Attributes$class('text-sm font-medium text-gray-800')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(message)
			]));
};
var $author$project$Notification$viewNotification = F2(
	function (config, notification) {
		var viewIcon = function () {
			var _v1 = notification.k;
			switch (_v1) {
				case 0:
					return $author$project$Pwr$Ui$Icon$info;
				case 1:
					return $author$project$Pwr$Ui$Icon$info;
				case 2:
					return $author$project$Pwr$Ui$Icon$error;
				case 3:
					return $author$project$Pwr$Ui$Icon$check;
				case 4:
					return $author$project$Pwr$Ui$Icon$error;
				default:
					return $author$project$Pwr$Ui$Icon$error;
			}
		}();
		var severityToTestAttr = function () {
			var _v0 = notification.k;
			switch (_v0) {
				case 0:
					return 'info-icon';
				case 1:
					return 'info-icon';
				case 2:
					return 'alert-icon';
				case 3:
					return 'success-icon';
				case 4:
					return 'alert-icon';
				default:
					return 'alert-icon';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('rounded-md shadow-lg py-3 px-4 w-full sm:w-96 bg-white border-l-4'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('border-green-700', notification.k === 3),
							_Utils_Tuple2('border-red-600', (notification.k === 4) || (notification.k === 5)),
							_Utils_Tuple2('border-blue-500', (!notification.k) || (notification.k === 1)),
							_Utils_Tuple2('border-yellow-500', notification.k === 2)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-shrink-0'),
									$author$project$Pwr$Test$attribute(severityToTestAttr)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Pwr$Ui$Icon$view,
									_List_fromArray(
										[
											$author$project$Pwr$Ui$Icon$class('h-6 w-6 flex-shrink-0 rounded-full'),
											$author$project$Pwr$Ui$Icon$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('text-green-700 border-2 border-green-700', notification.k === 3),
													_Utils_Tuple2('text-red-600', (notification.k === 4) || (notification.k === 5)),
													_Utils_Tuple2('text-blue-500', (!notification.k) || (notification.k === 1)),
													_Utils_Tuple2('text-yellow-500', notification.k === 2)
												]))
										]),
									viewIcon)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-3')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Notification$viewMessage,
								A2($elm$core$String$split, '\n', notification.dl))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-auto pl-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('-mx-1.5 -my-1.5')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('button'),
													$elm$html$Html$Attributes$class('inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2 hover:bg-gray-100'),
													$elm$html$Html$Events$onClick(
													config.cc(notification))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('sr-only'),
															$author$project$Pwr$Test$attribute('dismiss-notification')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Dismiss')
														])),
													A2(
													$author$project$Pwr$Ui$Icon$view,
													_List_fromArray(
														[
															$author$project$Pwr$Ui$Icon$class('h-5 w-5')
														]),
													$author$project$Pwr$Ui$Icon$cancel)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Notification$view = function (config) {
	var _v0 = config.b9;
	if (!_v0.b) {
		return $author$project$Html$Extra$none;
	} else {
		var notifications = _v0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fixed inset-x-0 top-0 sm:right-0 sm:left-auto space-y-4 sm:mt-16 sm:mr-24 z-50')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Notification$viewNotification(config),
				notifications));
	}
};
var $author$project$Page$wrapView = F2(
	function (view, outerModel) {
		if (outerModel.$ === 1) {
			var error = outerModel.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container mx-auto py-24')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Failed to start program, this is usually due to the failure to decode the intial state.')
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Decode Error: '),
								$elm$html$Html$text(
								$elm$json$Json$Decode$errorToString(error))
							]))
					]));
		} else {
			var notifications = outerModel.a.b9;
			var model = outerModel.a.aE;
			return A2(
				$elm$html$Html$main_,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Notification$view(
						{b9: notifications, cc: $author$project$Page$ClickedDismissNotification}),
						A2(
						$elm$html$Html$map,
						$author$project$Page$PageMsg,
						view(model))
					]));
		}
	});
var $author$project$Page$program = function (config) {
	var init = function (flags) {
		var _v0 = A2(
			$elm$json$Json$Decode$decodeValue,
			$author$project$Page$flagsDecoder(config.db),
			flags);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var notifications = _v1.a;
			var decodedFlags = _v1.b;
			return A3(
				$elm$core$Tuple$mapBoth,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Page$Running,
					$author$project$Page$Internal(notifications)),
				$elm$core$Platform$Cmd$map($author$project$Page$PageMsg),
				config.bV(decodedFlags));
		} else {
			var e = _v0.a;
			return _Utils_Tuple2(
				$author$project$Page$StartupFailure(e),
				$elm$core$Platform$Cmd$none);
		}
	};
	return $elm$browser$Browser$element(
		{
			bV: init,
			cN: $author$project$Page$wrapSubscriptions(config.cN),
			cR: $author$project$Page$wrapUpdate(config.cR),
			cV: $author$project$Page$wrapView(config.cV)
		});
};
var $author$project$Route$AgentLogin = {$: 44};
var $author$project$Page$Agents$AccountAccess$EmailMalformatted = 2;
var $author$project$Page$Agents$AccountAccess$FirstNameBlank = 0;
var $author$project$Page$Agents$AccountAccess$GotAgentCreated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Agents$AccountAccess$GotMagicLinkResponse = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$Agents$AccountAccess$GotResendEmail = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Agents$AccountAccess$LastNameBlank = 1;
var $author$project$Page$Agents$AccountAccess$LoginEmailMalformatted = 0;
var $author$project$Page$Agents$AccountAccess$MissingAgreeToTerms = 3;
var $author$project$Route$NewAgent = {$: 43};
var $author$project$Page$Agents$AccountAccess$NoOp = {$: 19};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Notification$severityToString = function (severity) {
	switch (severity) {
		case 0:
			return 'info';
		case 1:
			return 'notice';
		case 2:
			return 'warning';
		case 3:
			return 'success';
		case 4:
			return 'error';
		default:
			return 'alert';
	}
};
var $author$project$Notification$encoder = function (notification) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'severity',
				$elm$json$Json$Encode$string(
					$author$project$Notification$severityToString(notification.k))),
				_Utils_Tuple2(
				'message',
				$elm$json$Json$Encode$string(notification.dl))
			]));
};
var $author$project$Page$pageOutbound = _Platform_outgoingPort('pageOutbound', $elm$core$Basics$identity);
var $author$project$Page$addNotification = function (notification) {
	return $author$project$Page$pageOutbound(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tag',
					$elm$json$Json$Encode$string('AddNotification')),
					_Utils_Tuple2(
					'notification',
					$author$project$Notification$encoder(notification))
				])));
};
var $author$project$Api$Endpoint$Endpoint = $elm$core$Basics$identity;
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Api$Endpoint$url = F2(
	function (paths, queryParams) {
		return A2($elm$url$Url$Builder$absolute, paths, queryParams);
	});
var $author$project$Api$Endpoint$agents = A2(
	$author$project$Api$Endpoint$url,
	_List_fromArray(
		['agents']),
	_List_Nil);
var $elm$json$Json$Encode$bool = _Json_wrap;
var $NoRedInk$elm_rails$Rails$Expect = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $NoRedInk$elm_rails$Rails$Text = 0;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.cL));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $NoRedInk$elm_rails$Rails$expectEmptyBody = function (toMsg) {
	return A2(
		$NoRedInk$elm_rails$Rails$Expect,
		0,
		$elm$http$Http$expectString(
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$map(
					function (_v0) {
						return 0;
					}),
				toMsg)));
};
var $rtfeldman$elm_validate$Validate$fromValid = function (_v0) {
	var subject = _v0;
	return subject;
};
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {cv: reqs, cM: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.ax;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.cv));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.cM)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					c2: r.c2,
					x: r.x,
					s: A2(_Http_mapExpect, func, r.s),
					ar: r.ar,
					at: r.at,
					av: r.av,
					ax: r.ax,
					w: r.w
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{c2: false, x: r.x, s: r.s, ar: r.ar, at: r.at, av: r.av, ax: r.ax, w: r.w}));
};
var $NoRedInk$elm_rails$Rails$request = function (_v0) {
	var method = _v0.at;
	var headers = _v0.ar;
	var url = _v0.w;
	var body = _v0.x;
	var expect = _v0.s;
	var timeout = _v0.av;
	var tracker = _v0.ax;
	var requestedWith = A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest');
	var accept = function () {
		if (expect.a === 1) {
			var _v3 = expect.a;
			return A2($elm$http$Http$header, 'Accept', 'application/json, text/javascript, */*; q=0.01');
		} else {
			var _v4 = expect.a;
			return A2($elm$http$Http$header, 'Accept', '*/*');
		}
	}();
	var _v1 = expect;
	var unwrappedExpect = _v1.b;
	return $elm$http$Http$request(
		{
			x: body,
			s: unwrappedExpect,
			ar: A2(
				$elm$core$List$cons,
				accept,
				A2($elm$core$List$cons, requestedWith, headers)),
			at: method,
			av: timeout,
			ax: tracker,
			w: url
		});
};
var $author$project$Api$Endpoint$unwrap = function (_v0) {
	var str = _v0;
	return str;
};
var $author$project$Api$Endpoint$request = function (config) {
	return $NoRedInk$elm_rails$Rails$request(
		{
			x: config.x,
			s: config.s,
			ar: config.ar,
			at: config.at,
			av: config.av,
			ax: config.ax,
			w: $author$project$Api$Endpoint$unwrap(config.w)
		});
};
var $author$project$Api$post = function (_v0) {
	var url = _v0.w;
	var expect = _v0.s;
	var body = _v0.x;
	return $author$project$Api$Endpoint$request(
		{x: body, s: expect, ar: _List_Nil, at: 'POST', av: $elm$core$Maybe$Nothing, ax: $elm$core$Maybe$Nothing, w: url});
};
var $author$project$Pwr$Agent$create = F3(
	function (validForm, invited, tagger) {
		var form = $rtfeldman$elm_validate$Validate$fromValid(validForm);
		return $author$project$Api$post(
			{
				x: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'agent',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'first_name',
											$elm$json$Json$Encode$string(form.J)),
											_Utils_Tuple2(
											'last_name',
											$elm$json$Json$Encode$string(form.M)),
											_Utils_Tuple2(
											'email',
											$elm$json$Json$Encode$string(form.B))
										]))),
								_Utils_Tuple2(
								'invited',
								$elm$json$Json$Encode$bool(invited))
							]))),
				s: $NoRedInk$elm_rails$Rails$expectEmptyBody(tagger),
				w: $author$project$Api$Endpoint$agents
			});
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $pzp1997$assoc_list$AssocList$remove = F2(
	function (targetKey, _v0) {
		var alist = _v0;
		return A2(
			$elm$core$List$filter,
			function (_v1) {
				var key = _v1.a;
				return !_Utils_eq(key, targetKey);
			},
			alist);
	});
var $pzp1997$assoc_list$AssocList$insert = F3(
	function (key, value, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$remove, key, dict);
		var alteredAlist = _v0;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(key, value),
			alteredAlist);
	});
var $erlandsona$assoc_set$AssocSet$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($pzp1997$assoc_list$AssocList$insert, key, 0, dict);
	});
var $erlandsona$assoc_set$AssocSet$fromList = function (list) {
	return A3($elm$core$List$foldl, $erlandsona$assoc_set$AssocSet$insert, $erlandsona$assoc_set$AssocSet$empty, list);
};
var $author$project$Page$Agents$AccountAccess$NotFound = 0;
var $author$project$Page$Agents$AccountAccess$PendingConfirmation = 2;
var $author$project$Page$Agents$AccountAccess$PendingDelete = 3;
var $author$project$Page$Agents$AccountAccess$Suspended = 1;
var $author$project$Page$Agents$AccountAccess$Unknown = 4;
var $author$project$Page$Agents$AccountAccess$httpErrorToAccountError = function (err) {
	_v0$4:
	while (true) {
		if (err.$ === 3) {
			switch (err.a) {
				case 422:
					return 0;
				case 401:
					return 2;
				case 403:
					return 1;
				case 410:
					return 3;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return 4;
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {dg: index, dk: match, dm: number, dD: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$never = _Regex_never;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Validate$Extra$validEmail = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{aL: true, a$: false},
		'^\\S+@\\S+\\.\\S+$'));
var $author$project$Validate$Extra$isValidEmailAddress = function (email) {
	return A2($elm$regex$Regex$contains, $author$project$Validate$Extra$validEmail, email);
};
var $erlandsona$assoc_set$AssocSet$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($pzp1997$assoc_list$AssocList$remove, key, dict);
	});
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$String$Extra$fromBool = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$Pwr$PwrProfile$id = function (_v0) {
	var profile = _v0;
	return profile.bP;
};
var $author$project$Constants$instagramUrl = 'https://www.instagram.com';
var $author$project$Pwr$IgPost$postUrl = function (_v0) {
	var post = _v0;
	return post.a3;
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $pzp1997$assoc_list$AssocList$keys = function (_v0) {
	var alist = _v0;
	return A2($elm$core$List$map, $elm$core$Tuple$first, alist);
};
var $erlandsona$assoc_set$AssocSet$toList = function (_v0) {
	var dict = _v0;
	return $pzp1997$assoc_list$AssocList$keys(dict);
};
var $author$project$Pwr$Agent$AgentId$toString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Pwr$BulkPersona$BulkPersonaId$toString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Pwr$Bundle$BundleId$toString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Pwr$BundleEmailTemplate$BundleEmailTemplateId$toString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Pwr$BundledProduct$BundledProductId$toString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Pwr$Campaign$CampaignId$toString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Pwr$Campaign$SortOrder$toString = function (sort) {
	switch (sort) {
		case 0:
			return 'oldest_first';
		case 1:
			return 'newest_first';
		default:
			return 'last_edited';
	}
};
var $author$project$Pwr$CampaignEmailTemplate$CampaignEmailTemplateId$toString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Pwr$EmailTemplate$EmailTemplateId$toString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Pwr$EmailTemplateSet$EmailTemplateSetId$toString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Pwr$Persona$PersonaId$toString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Pwr$PlatformEmailTemplate$PlatformEmailTemplateId$toString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Pwr$PwrProfile$PwrProfileId$toString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Pwr$Review$SortOrder$toString = function (sort) {
	switch (sort) {
		case 0:
			return 'oldest_first';
		case 1:
			return 'newest_first';
		case 2:
			return 'highest_rated';
		default:
			return 'lowest_rated';
	}
};
var $author$project$Pwr$Slug$toString = function (_v0) {
	var str = _v0;
	return str;
};
var $elm$time$Time$Jan = 0;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$modBy = _Basics_modBy;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {bu: d, b6: m, c1: y};
			}
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		a1: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		c1: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.c1, 0, date.a1);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.bu;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.b6;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.a1;
	});
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		cZ: 1 + (((rd - week1Day1) / 7) | 0),
		c_: wy,
		dG: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.cZ;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.c_;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.aF(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.a_(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.aF(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.aO(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.ad(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.ad(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.ad(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.bc(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.ad(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.ad(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {bp: col, c8: contextStack, cm: problem, cA: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.cA, s.bp, x, s.c));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.b, s.cA, s.bp, s.a);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{bp: newCol, c: s.c, d: s.d, b: newOffset, cA: newRow, a: s.a});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.b, s.a);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{bp: 1, c: s.c, d: s.d, b: s.b + 1, cA: s.cA + 1, a: s.a}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{bp: s.bp + 1, c: s.c, d: s.d, b: newOffset, cA: s.cA, a: s.a}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.a);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.b, offset) < 0,
					0,
					{bp: col, c: s0.c, d: s0.d, b: offset, cA: row, a: s0.a});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.b, s.cA, s.bp, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.b, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.b, s1.b, s0.a),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.a),
			s.b) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {bp: col, cm: problem, cA: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.cA, p.bp, p.cm);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{bp: 1, c: _List_Nil, d: 1, b: 0, cA: 1, a: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	aO: $justinmimbs$date$Date$withOrdinalSuffix,
	a_: $justinmimbs$date$Date$monthToName,
	aF: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	bc: $justinmimbs$date$Date$weekdayToName,
	ad: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $author$project$Date$Extra$toStrpString = function (date) {
	return A2($justinmimbs$date$Date$format, 'dd/MM/yyyy', date);
};
var $author$project$Pwr$Observation$Behavior$toValue = function (behavior) {
	switch (behavior) {
		case 0:
			return 'courier_zip';
		case 1:
			return 'multiple_accounts';
		case 2:
			return 'multiple_address_mates';
		case 3:
			return 'ghost';
		case 4:
			return 'malicious_intent';
		case 5:
			return 'po_box';
		case 6:
			return 'foreign_address';
		case 7:
			return 'other';
		default:
			return 'short_review';
	}
};
var $author$project$Pwr$Agent$InstagramUser$username = function (_v0) {
	var user = _v0;
	return user.dE;
};
var $author$project$Route$toString = function (page) {
	switch (page.$) {
		case 0:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['campaigns']),
				_List_Nil);
		case 1:
			var query = page.a;
			var statuses = page.b;
			var owners = page.c;
			var sort = page.d;
			var statusesQueryParams = A2(
				$elm$core$List$map,
				function (status) {
					return A2($elm$url$Url$Builder$string, 'statuses[]', status);
				},
				$erlandsona$assoc_set$AssocSet$toList(statuses));
			var sortQueryParam = $elm$core$List$singleton(
				A2(
					$elm$url$Url$Builder$string,
					'sort',
					$author$project$Pwr$Campaign$SortOrder$toString(sort)));
			var ownersQueryParams = A2(
				$elm$core$List$map,
				function (owner) {
					return A2(
						$elm$url$Url$Builder$string,
						'owners[]',
						$author$project$Pwr$PwrProfile$PwrProfileId$toString(
							$author$project$Pwr$PwrProfile$id(owner)));
				},
				$erlandsona$assoc_set$AssocSet$toList(owners));
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['campaigns']),
				A2(
					$elm$core$List$cons,
					A2($elm$url$Url$Builder$string, 'q', query),
					_Utils_ap(
						statusesQueryParams,
						_Utils_ap(ownersQueryParams, sortQueryParam))));
		case 3:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id)
					]),
				_List_Nil);
		case 4:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'setup'
					]),
				_List_Nil);
		case 5:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'participants'
					]),
				_List_Nil);
		case 7:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'participants'
					]),
				_List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'refresh', 'true')
					]));
		case 6:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'selected-participants'
					]),
				_List_Nil);
		case 8:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'manage'
					]),
				_List_Nil);
		case 9:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'summary_report'
					]),
				_List_Nil);
		case 13:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['meta_integrations', 'instagram_auth']),
				_List_Nil);
		case 14:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['meta_integrations', 'disconnect_instagram']),
				_List_Nil);
		case 2:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['campaigns', 'new']),
				_List_Nil);
		case 19:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'edit'
					]),
				_List_Nil);
		case 10:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'campaign_email_templates'
					]),
				_List_Nil);
		case 11:
			var campaignId = page.a;
			var emailTemplateId = page.b;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(campaignId),
						'campaign_email_templates',
						function () {
						if (!emailTemplateId) {
							return 'Invitation To Apply';
						} else {
							return 'Thank You For Your Application';
						}
					}()
					]),
				_List_Nil);
		case 15:
			var campaignId = page.a;
			var bundleId = page.b;
			var emailTemplate = page.c;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(campaignId),
						'bundles',
						$author$project$Pwr$Bundle$BundleId$toString(bundleId),
						'bundle_email_templates',
						function () {
						switch (emailTemplate) {
							case 0:
								return 'Campaign Confirmation';
							case 1:
								return 'Shipment Confirmation';
							case 2:
								return 'Posting Instructions';
							case 3:
								return 'Posting Instructions - Reminder 1';
							case 4:
								return 'Posting Instructions - Reminder 2';
							case 5:
								return 'Posting Instructions - Reminder 3';
							case 6:
								return 'Break Up Email';
							default:
								return 'Review Completion';
						}
					}()
					]),
				_List_Nil);
		case 17:
			var campaignId = page.a;
			var cetId = page.b;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(campaignId),
						'campaign_email_templates',
						$author$project$Pwr$CampaignEmailTemplate$CampaignEmailTemplateId$toString(cetId),
						'edit'
					]),
				_List_Nil);
		case 16:
			var campaignId = page.a;
			var bundleId = page.b;
			var emailTemplateId = page.c;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(campaignId),
						'bundles',
						$author$project$Pwr$Bundle$BundleId$toString(bundleId),
						'bundle_email_templates',
						$author$project$Pwr$BundleEmailTemplate$BundleEmailTemplateId$toString(emailTemplateId),
						'edit'
					]),
				_List_Nil);
		case 18:
			var campaignId = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(campaignId),
						'download_participants'
					]),
				_List_Nil);
		case 20:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['emails']),
				_List_Nil);
		case 21:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'email_template_sets',
						$author$project$Pwr$EmailTemplateSet$EmailTemplateSetId$toString(id)
					]),
				_List_Nil);
		case 22:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'email_template_sets',
						$author$project$Pwr$EmailTemplateSet$EmailTemplateSetId$toString(id),
						'email_templates'
					]),
				_List_Nil);
		case 24:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'email_templates',
						$author$project$Pwr$EmailTemplate$EmailTemplateId$toString(id)
					]),
				_List_Nil);
		case 23:
			var emailTemplateSetId = page.a;
			var id = page.b;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'email_template_sets',
						$author$project$Pwr$EmailTemplateSet$EmailTemplateSetId$toString(emailTemplateSetId),
						'email_templates',
						$author$project$Pwr$EmailTemplate$EmailTemplateId$toString(id),
						'edit'
					]),
				_List_Nil);
		case 25:
			var platformEmailTemplateId = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'platform_email_templates',
						$author$project$Pwr$PlatformEmailTemplate$PlatformEmailTemplateId$toString(platformEmailTemplateId),
						'edit'
					]),
				_List_Nil);
		case 26:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'adhoc_email'
					]),
				_List_Nil);
		case 27:
			var id = page.a;
			var agentId = page.b;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'adhoc_email'
					]),
				_List_fromArray(
					[
						A2(
						$elm$url$Url$Builder$string,
						'agent_id',
						$author$project$Pwr$Agent$AgentId$toString(agentId))
					]));
		case 28:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'adhoc_email',
						'cancel_campaign_email'
					]),
				_List_Nil);
		case 29:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'adhoc_bulk_remove'
					]),
				_List_Nil);
		case 30:
			var campaignId = page.a;
			var bundleId = page.b;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(campaignId),
						'bundles',
						$author$project$Pwr$Bundle$BundleId$toString(bundleId),
						'adhoc_bulk_remove'
					]),
				_List_Nil);
		case 31:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'filter'
					]),
				_List_Nil);
		case 32:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'survey'
					]),
				_List_Nil);
		case 33:
			var slug = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'surveys',
						$author$project$Pwr$Slug$toString(slug)
					]),
				_List_Nil);
		case 34:
			var slug = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'surveys',
						$author$project$Pwr$Slug$toString(slug),
						'preview'
					]),
				_List_Nil);
		case 35:
			var slug = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'surveys',
						$author$project$Pwr$Slug$toString(slug),
						'thank-you'
					]),
				_List_Nil);
		case 36:
			var bundleId = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'bundles',
						$author$project$Pwr$Bundle$BundleId$toString(bundleId),
						'personas',
						'new'
					]),
				_List_Nil);
		case 39:
			var campaignId = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(campaignId),
						'bulk_personas',
						'new'
					]),
				_List_Nil);
		case 40:
			var campaignId = page.a;
			var bulkPersonaId = page.b;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(campaignId),
						'bulk_personas',
						$author$project$Pwr$BulkPersona$BulkPersonaId$toString(bulkPersonaId),
						'edit'
					]),
				_List_Nil);
		case 37:
			var personaId = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'personas',
						$author$project$Pwr$Persona$PersonaId$toString(personaId),
						'edit'
					]),
				_List_Nil);
		case 38:
			var personaId = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'personas',
						$author$project$Pwr$Persona$PersonaId$toString(personaId)
					]),
				_List_Nil);
		case 41:
			var slug = page.a;
			var bundledProductId = page.b;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Slug$toString(slug),
						'bundled_products',
						$author$project$Pwr$BundledProduct$BundledProductId$toString(bundledProductId),
						'review'
					]),
				_List_Nil);
		case 42:
			var campaignId = page.a;
			var bundledProductId = page.b;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(campaignId),
						'bundled_products',
						$author$project$Pwr$BundledProduct$BundledProductId$toString(bundledProductId),
						'reviews'
					]),
				_List_Nil);
		case 43:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['agents', 'new']),
				_List_Nil);
		case 44:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['agent-login']),
				_List_Nil);
		case 45:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['agent-logout']),
				_List_Nil);
		case 46:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['home']),
				_List_Nil);
		case 47:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['profile']),
				_List_Nil);
		case 52:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['profile', 'campaigns']),
				_List_Nil);
		case 53:
			var slug = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'profile',
						'campaigns',
						$author$project$Pwr$Slug$toString(slug)
					]),
				_List_Nil);
		case 54:
			var slug = page.a;
			var bundledProductId = page.b;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'profile',
						'campaigns',
						$author$project$Pwr$Slug$toString(slug),
						'bundled_products',
						$author$project$Pwr$BundledProduct$BundledProductId$toString(bundledProductId)
					]),
				_List_Nil);
		case 55:
			var slug = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'profile',
						'campaigns',
						$author$project$Pwr$Slug$toString(slug),
						'ig_posts'
					]),
				_List_Nil);
		case 48:
			var socialSection = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['profile', 'more']),
				_List_fromArray(
					[
						A2(
						$elm$url$Url$Builder$string,
						'show_social',
						$author$project$String$Extra$fromBool(socialSection))
					]));
		case 49:
			var justActivated = page.a;
			var queryParams = justActivated ? _List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'o', 'true')
				]) : _List_Nil;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['profile']),
				queryParams);
		case 50:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['onboarding']),
				_List_Nil);
		case 51:
			var justActivated = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['optional_onboarding']),
				_List_fromArray(
					[
						A2(
						$elm$url$Url$Builder$string,
						'o',
						$author$project$String$Extra$fromBool(justActivated))
					]));
		case 56:
			var agentId = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'community',
						'agents',
						$author$project$Pwr$Agent$AgentId$toString(agentId)
					]),
				_List_Nil);
		case 57:
			var agentId = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'community',
						'agents',
						$author$project$Pwr$Agent$AgentId$toString(agentId),
						'account_history'
					]),
				_List_Nil);
		case 58:
			var agentId = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'community',
						'agents',
						$author$project$Pwr$Agent$AgentId$toString(agentId),
						'campaigns'
					]),
				_List_Nil);
		case 59:
			var agentId = page.a;
			var campaignId = page.b;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'community',
						'agents',
						$author$project$Pwr$Agent$AgentId$toString(agentId),
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(campaignId)
					]),
				_List_Nil);
		case 60:
			var agentId = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'community',
						'agents',
						$author$project$Pwr$Agent$AgentId$toString(agentId),
						'campaign-history'
					]),
				_List_Nil);
		case 61:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['community', 'moderation']),
				_List_Nil);
		case 12:
			var campaignId = page.a;
			var bundleId = page.b;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(campaignId),
						'bundles',
						$author$project$Pwr$Bundle$BundleId$toString(bundleId),
						'instagram',
						'posts'
					]),
				_List_Nil);
		case 62:
			var observations = page.a;
			var observationsQuery = A2(
				$elm$core$List$map,
				function (status) {
					return A2($elm$url$Url$Builder$string, 'observations[]', status);
				},
				A2($elm$core$List$map, $author$project$Pwr$Observation$Behavior$toValue, observations));
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['community', 'moderation']),
				observationsQuery);
		case 63:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['community', 'agents']),
				_List_Nil);
		case 64:
			var campaignId = page.a;
			var bundledProductId = page.b;
			var query = page.c;
			var sort = page.d;
			var sortQueryParam = $elm$core$List$singleton(
				A2(
					$elm$url$Url$Builder$string,
					'sort',
					$author$project$Pwr$Review$SortOrder$toString(sort)));
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(campaignId),
						'bundled_products',
						$author$project$Pwr$BundledProduct$BundledProductId$toString(bundledProductId),
						'reviews'
					]),
				A2(
					$elm$core$List$cons,
					A2($elm$url$Url$Builder$string, 'q', query),
					sortQueryParam));
		case 65:
			var date = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['reports', 'system']),
				_List_fromArray(
					[
						A2(
						$elm$url$Url$Builder$string,
						'selected_quarter',
						$author$project$Date$Extra$toStrpString(date))
					]));
		case 66:
			var id = page.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'campaigns',
						$author$project$Pwr$Campaign$CampaignId$toString(id),
						'export_summary_report'
					]),
				_List_Nil);
		default:
			if (!page.a.$) {
				var igUser = page.a.a;
				return A3(
					$elm$url$Url$Builder$crossOrigin,
					$author$project$Constants$instagramUrl,
					_List_fromArray(
						[
							$author$project$Pwr$Agent$InstagramUser$username(igUser)
						]),
					_List_Nil);
			} else {
				var igPost = page.a.a;
				return $author$project$Pwr$IgPost$postUrl(igPost);
			}
	}
};
var $author$project$Page$replaceUrl = function (route) {
	return $author$project$Page$pageOutbound(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tag',
					$elm$json$Json$Encode$string('ReplaceRoute')),
					_Utils_Tuple2(
					'url',
					$elm$json$Json$Encode$string(
						$author$project$Route$toString(route)))
				])));
};
var $author$project$Api$Endpoint$agentsResendConfirmation = A2(
	$author$project$Api$Endpoint$url,
	_List_fromArray(
		['agents', 'resend_confirmation_email']),
	_List_Nil);
var $author$project$Api$put = function (_v0) {
	var url = _v0.w;
	var expect = _v0.s;
	var body = _v0.x;
	return $author$project$Api$Endpoint$request(
		{x: body, s: expect, ar: _List_Nil, at: 'PUT', av: $elm$core$Maybe$Nothing, ax: $elm$core$Maybe$Nothing, w: url});
};
var $author$project$Pwr$Agent$resendEmail = F2(
	function (email_, tagger) {
		return $author$project$Api$put(
			{
				x: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(email_))
							]))),
				s: $NoRedInk$elm_rails$Rails$expectEmptyBody(tagger),
				w: $author$project$Api$Endpoint$agentsResendConfirmation
			});
	});
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $author$project$Browser$Dom$Extra$resetViewport = function (tagger) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return tagger;
		},
		A2($elm$browser$Browser$Dom$setViewport, -1, -1));
};
var $author$project$SelectList$selectHelp = F4(
	function (isSelectable, beforeList, selectedElem, afterList) {
		var _v0 = _Utils_Tuple2(beforeList, afterList);
		if (!_v0.a.b) {
			if (!_v0.b.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v1 = _v0.b;
				var first = _v1.a;
				var rest = _v1.b;
				if (isSelectable(selectedElem)) {
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(beforeList, selectedElem, afterList));
				} else {
					if (isSelectable(first)) {
						return $elm$core$Maybe$Just(
							_Utils_Tuple3(
								_Utils_ap(
									beforeList,
									_List_fromArray(
										[selectedElem])),
								first,
								rest));
					} else {
						var _v2 = A4($author$project$SelectList$selectHelp, isSelectable, _List_Nil, first, rest);
						if (_v2.$ === 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							var _v3 = _v2.a;
							var newBefore = _v3.a;
							var newSelected = _v3.b;
							var newAfter = _v3.c;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									A2($elm$core$List$cons, selectedElem, newBefore),
									newSelected,
									newAfter));
						}
					}
				}
			}
		} else {
			var _v4 = _v0.a;
			var first = _v4.a;
			var rest = _v4.b;
			if (isSelectable(first)) {
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(
						_List_Nil,
						first,
						_Utils_ap(
							rest,
							A2($elm$core$List$cons, selectedElem, afterList))));
			} else {
				var _v5 = A4($author$project$SelectList$selectHelp, isSelectable, rest, selectedElem, afterList);
				if (_v5.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v6 = _v5.a;
					var newBefore = _v6.a;
					var newSelected = _v6.b;
					var newAfter = _v6.c;
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(
							A2($elm$core$List$cons, first, newBefore),
							newSelected,
							newAfter));
				}
			}
		}
	});
var $author$project$SelectList$select = F2(
	function (isSelectable, original) {
		var beforeSel = original.a;
		var sel = original.b;
		var afterSel = original.c;
		var _v0 = A4($author$project$SelectList$selectHelp, isSelectable, beforeSel, sel, afterSel);
		if (_v0.$ === 1) {
			return original;
		} else {
			var _v1 = _v0.a;
			var newBefore = _v1.a;
			var newSel = _v1.b;
			var newAfter = _v1.c;
			return A3($author$project$SelectList$SelectList, newBefore, newSel, newAfter);
		}
	});
var $author$project$SelectList$selected = function (_v0) {
	var sel = _v0.b;
	return sel;
};
var $author$project$Api$Endpoint$agentsSignIn = A2(
	$author$project$Api$Endpoint$url,
	_List_fromArray(
		['magic_links']),
	_List_Nil);
var $author$project$Pwr$Agent$signIn = F3(
	function (email_, remember, tagger) {
		return $author$project$Api$post(
			{
				x: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$core$Maybe$Just(
									_Utils_Tuple2(
										'email',
										$elm$json$Json$Encode$string(email_))),
									remember ? $elm$core$Maybe$Just(
									_Utils_Tuple2(
										'remember',
										$elm$json$Json$Encode$bool(remember))) : $elm$core$Maybe$Nothing
								])))),
				s: $NoRedInk$elm_rails$Rails$expectEmptyBody(tagger),
				w: $author$project$Api$Endpoint$agentsSignIn
			});
	});
var $elm$core$String$trim = _String_trim;
var $author$project$Page$Agents$AccountAccess$trimForm = function (form) {
	return _Utils_update(
		form,
		{
			B: $elm$core$String$trim(form.B),
			J: $elm$core$String$trim(form.J),
			M: $elm$core$String$trim(form.M)
		});
};
var $pzp1997$assoc_list$AssocList$union = F2(
	function (_v0, rightDict) {
		var leftAlist = _v0;
		return A3(
			$elm$core$List$foldr,
			F2(
				function (_v1, result) {
					var lKey = _v1.a;
					var lValue = _v1.b;
					return A3($pzp1997$assoc_list$AssocList$insert, lKey, lValue, result);
				}),
			rightDict,
			leftAlist);
	});
var $erlandsona$assoc_set$AssocSet$union = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($pzp1997$assoc_list$AssocList$union, dict1, dict2);
	});
var $author$project$Page$Agents$AccountAccess$updateForm = F2(
	function (transform, model) {
		return _Utils_update(
			model,
			{
				l: transform(model.l)
			});
	});
var $rtfeldman$elm_validate$Validate$Valid = $elm$core$Basics$identity;
var $rtfeldman$elm_validate$Validate$validate = F2(
	function (_v0, subject) {
		var getErrors = _v0;
		var _v1 = getErrors(subject);
		if (!_v1.b) {
			return $elm$core$Result$Ok(subject);
		} else {
			var errors = _v1;
			return $elm$core$Result$Err(errors);
		}
	});
var $rtfeldman$elm_validate$Validate$Validator = $elm$core$Basics$identity;
var $rtfeldman$elm_validate$Validate$ifFalse = F2(
	function (test, error) {
		var getErrors = function (subject) {
			return test(subject) ? _List_Nil : _List_fromArray(
				[error]);
		};
		return getErrors;
	});
var $author$project$Page$Agents$AccountAccess$validateAgreedToTerms = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	function ($) {
		return $.ai;
	},
	3);
var $author$project$Page$Agents$AccountAccess$validateEmail = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	function (form) {
		return $author$project$Validate$Extra$isValidEmailAddress(form.B);
	},
	2);
var $rtfeldman$elm_validate$Validate$ifTrue = F2(
	function (test, error) {
		var getErrors = function (subject) {
			return test(subject) ? _List_fromArray(
				[error]) : _List_Nil;
		};
		return getErrors;
	});
var $rtfeldman$elm_validate$Validate$isWhitespaceChar = function (_char) {
	return (_char === ' ') || ((_char === '\n') || ((_char === '\t') || (_char === '\u000D')));
};
var $rtfeldman$elm_validate$Validate$isBlank = function (str) {
	isBlank:
	while (true) {
		var _v0 = $elm$core$String$uncons(str);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var _char = _v1.a;
			var rest = _v1.b;
			if ($rtfeldman$elm_validate$Validate$isWhitespaceChar(_char)) {
				var $temp$str = rest;
				str = $temp$str;
				continue isBlank;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
};
var $rtfeldman$elm_validate$Validate$ifBlank = F2(
	function (subjectToString, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return $rtfeldman$elm_validate$Validate$isBlank(
					subjectToString(subject));
			},
			error);
	});
var $author$project$Page$Agents$AccountAccess$validateFirstName = A2(
	$rtfeldman$elm_validate$Validate$ifBlank,
	function (form) {
		return $elm$core$String$trim(form.J);
	},
	0);
var $author$project$Page$Agents$AccountAccess$validateLastName = A2(
	$rtfeldman$elm_validate$Validate$ifBlank,
	function (form) {
		return $elm$core$String$trim(form.M);
	},
	1);
var $author$project$Page$Agents$AccountAccess$validateLoginEmail = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	function (loginEmail) {
		return $author$project$Validate$Extra$isValidEmailAddress(loginEmail);
	},
	0);
var $rtfeldman$elm_validate$Validate$all = function (validators) {
	var newGetErrors = function (subject) {
		var accumulateErrors = F2(
			function (_v0, totalErrors) {
				var getErrors = _v0;
				return _Utils_ap(
					totalErrors,
					getErrors(subject));
			});
		return A3($elm$core$List$foldl, accumulateErrors, _List_Nil, validators);
	};
	return newGetErrors;
};
var $author$project$Page$Agents$AccountAccess$validateSignUp = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[$author$project$Page$Agents$AccountAccess$validateFirstName, $author$project$Page$Agents$AccountAccess$validateLastName, $author$project$Page$Agents$AccountAccess$validateEmail, $author$project$Page$Agents$AccountAccess$validateAgreedToTerms]));
var $author$project$Page$Agents$AccountAccess$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = A2(
					$rtfeldman$elm_validate$Validate$validate,
					$author$project$Page$Agents$AccountAccess$validateSignUp,
					$author$project$Page$Agents$AccountAccess$trimForm(model.l));
				if (!_v1.$) {
					var validForm = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l: $rtfeldman$elm_validate$Validate$fromValid(validForm),
								_: true
							}),
						A3($author$project$Pwr$Agent$create, validForm, false, $author$project$Page$Agents$AccountAccess$GotAgentCreated));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							f: A2(
								$author$project$SelectList$select,
								$elm$core$Basics$eq(3),
								model.f)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Y: true}),
					A2($author$project$Pwr$Agent$resendEmail, model.l.B, $author$project$Page$Agents$AccountAccess$GotResendEmail));
			case 3:
				var newModel = A2(
					$author$project$Page$Agents$AccountAccess$updateForm,
					function (form) {
						return _Utils_update(
							form,
							{ai: !form.ai});
					},
					model);
				var _v2 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Page$Agents$AccountAccess$validateAgreedToTerms, newModel.l);
				if (!_v2.$) {
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								g: A2($erlandsona$assoc_set$AssocSet$remove, 3, newModel.g)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errors = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								g: A2(
									$erlandsona$assoc_set$AssocSet$union,
									$erlandsona$assoc_set$AssocSet$fromList(errors),
									newModel.g)
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 4:
				var _v3 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Page$Agents$AccountAccess$validateFirstName, model.l);
				if (!_v3.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								g: A2($erlandsona$assoc_set$AssocSet$remove, 0, model.g)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errors = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								g: A2(
									$erlandsona$assoc_set$AssocSet$union,
									$erlandsona$assoc_set$AssocSet$fromList(errors),
									model.g)
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 5:
				var _v4 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Page$Agents$AccountAccess$validateLastName, model.l);
				if (!_v4.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								g: A2($erlandsona$assoc_set$AssocSet$remove, 1, model.g)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errors = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								g: A2(
									$erlandsona$assoc_set$AssocSet$union,
									$erlandsona$assoc_set$AssocSet$fromList(errors),
									model.g)
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 6:
				var _v5 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Page$Agents$AccountAccess$validateEmail, model.l);
				if (!_v5.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								g: A2($erlandsona$assoc_set$AssocSet$remove, 2, model.g)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errors = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								g: A2(
									$erlandsona$assoc_set$AssocSet$union,
									$erlandsona$assoc_set$AssocSet$fromList(errors),
									model.g)
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 7:
				var firstName = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Agents$AccountAccess$updateForm,
						function (form) {
							return _Utils_update(
								form,
								{J: firstName});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 8:
				var lastName = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Agents$AccountAccess$updateForm,
						function (form) {
							return _Utils_update(
								form,
								{M: lastName});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 9:
				var email = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Agents$AccountAccess$updateForm,
						function (form) {
							return _Utils_update(
								form,
								{B: email});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 10:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: ($author$project$SelectList$selected(model.f) === 3) ? model.f : A2(
									$author$project$SelectList$select,
									$elm$core$Basics$eq(1),
									model.f),
								_: false
							}),
						$author$project$Browser$Dom$Extra$resetViewport($author$project$Page$Agents$AccountAccess$NoOp));
				} else {
					var error = msg.a.a;
					if ((error.$ === 3) && (error.a === 409)) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{_: false}),
							$author$project$Page$addNotification(
								{dl: 'Email already in use.', k: 4}));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{_: false}),
							$author$project$Page$addNotification(
								{dl: 'Unexpected error. Please try again.', k: 4}));
					}
				}
			case 11:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: ($author$project$SelectList$selected(model.f) === 3) ? model.f : A2(
									$author$project$SelectList$select,
									$elm$core$Basics$eq(1),
									model.f),
								Y: false
							}),
						$author$project$Browser$Dom$Extra$resetViewport($author$project$Page$Agents$AccountAccess$NoOp));
				} else {
					var error = msg.a.a;
					if ((error.$ === 3) && (error.a === 409)) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{Y: false}),
							$author$project$Page$addNotification(
								{dl: 'Email already in use.', k: 4}));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{Y: false}),
							$author$project$Page$addNotification(
								{dl: 'Unexpected error. Please try again.', k: 4}));
					}
				}
			case 12:
				var email = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{C: email}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var _v8 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Page$Agents$AccountAccess$validateLoginEmail, model.C);
				if (!_v8.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								N: A2($erlandsona$assoc_set$AssocSet$remove, 0, model.N)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errors = _v8.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								N: A2(
									$erlandsona$assoc_set$AssocSet$union,
									$erlandsona$assoc_set$AssocSet$fromList(errors),
									model.N)
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{W: !model.W}),
					$elm$core$Platform$Cmd$none);
			case 15:
				return $author$project$Validate$Extra$isValidEmailAddress(model.C) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{v: true}),
					A3($author$project$Pwr$Agent$signIn, model.C, model.W, $author$project$Page$Agents$AccountAccess$GotMagicLinkResponse)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 16:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: A2(
									$author$project$SelectList$select,
									$elm$core$Basics$eq(2),
									model.f),
								v: false
							}),
						$author$project$Browser$Dom$Extra$resetViewport($author$project$Page$Agents$AccountAccess$NoOp));
				} else {
					var error = msg.a.a;
					var _v9 = $author$project$Page$Agents$AccountAccess$httpErrorToAccountError(error);
					switch (_v9) {
						case 0:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{v: false}),
								$author$project$Page$addNotification(
									{dl: 'Account not found.', k: 4}));
						case 1:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{v: false}),
								$author$project$Page$addNotification(
									{dl: 'Your account has been suspended. Please contact support if you have any questions.', k: 4}));
						case 2:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{v: false}),
								$author$project$Page$addNotification(
									{dl: 'You haven\'t activated your account! We sent you a new confirmation email. Please activate before logging in.', k: 2}));
						case 3:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{v: false}),
								$author$project$Page$addNotification(
									{dl: 'This account is being processed for deletion.', k: 2}));
						default:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{v: false}),
								$author$project$Page$addNotification(
									{dl: 'Unexpected error. Please try again.', k: 4}));
					}
				}
			case 17:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							f: A2(
								$author$project$SelectList$select,
								$elm$core$Basics$eq(0),
								model.f)
						}),
					$author$project$Page$replaceUrl($author$project$Route$NewAgent));
			case 18:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							f: A2(
								$author$project$SelectList$select,
								$elm$core$Basics$eq(4),
								model.f)
						}),
					$author$project$Page$replaceUrl($author$project$Route$AgentLogin));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pwr$Ui$Agent$Onboarding$Layout$init = function (tenant) {
	return {aA: $elm$core$Maybe$Nothing, S: false, o: tenant};
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$Html$Attributes$Extra$none = A2($elm$html$Html$Attributes$property, '', $elm$json$Json$Encode$null);
var $author$project$Html$Attributes$Extra$maybe = $elm$core$Maybe$withDefault($author$project$Html$Attributes$Extra$none);
var $author$project$Pwr$Ui$Agent$Onboarding$Layout$viewContent = F3(
	function (usingOverlay, attr, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					attr,
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('inline-block bg rounded-lg text-left', usingOverlay),
							_Utils_Tuple2('w-full max-w-[600px] md:max-w-none overflow-hidden', usingOverlay),
							_Utils_Tuple2('md:mt-[7vh] mb-8 md:p-4', usingOverlay),
							_Utils_Tuple2('md:transform md:transition-all md:duration-300 md:ease-in-out', usingOverlay)
						]))
				]),
			_List_fromArray(
				[content]));
	});
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $author$project$Pwr$Ui$Agent$Onboarding$Layout$defaultBackground = '/images/agent-onboarding/desktop-bg.jpg';
var $author$project$Pwr$Tenant$tenant_ = function (_v0) {
	var tenant = _v0;
	return tenant.aI;
};
var $author$project$Pwr$Ui$Agent$Onboarding$Layout$backgroundImage = function (tenant) {
	var _v0 = $author$project$Pwr$Tenant$tenant_(tenant);
	if (_v0 === 4) {
		return '/samsung/onboarding-bg.jpg';
	} else {
		return $author$project$Pwr$Ui$Agent$Onboarding$Layout$defaultBackground;
	}
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Route$AgentHome = {$: 46};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Route$href = function (targetRoute) {
	return $elm$html$Html$Attributes$href(
		$author$project$Route$toString(targetRoute));
};
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $author$project$Pwr$Tenant$displayName = function (_v0) {
	var tenant = _v0;
	var _v1 = tenant.aI;
	switch (_v1) {
		case 0:
			return 'BzzAgent';
		case 1:
			return 'John Lewis & Partners';
		case 2:
			return 'SalonCentric';
		case 3:
			return 'Demo Store';
		default:
			return 'Samsung';
	}
};
var $author$project$Pwr$Tenant$shortName = function (_v0) {
	var tenant = _v0;
	return tenant.cJ;
};
var $author$project$Pwr$Ui$Branding$Graphic$viewLogo = function (tenant) {
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('object-cover w-40'),
				$elm$html$Html$Attributes$src(
				$elm$core$String$concat(
					_List_fromArray(
						[
							'/',
							$author$project$Pwr$Tenant$shortName(tenant),
							'/',
							'logo.png'
						]))),
				$elm$html$Html$Attributes$alt(
				$author$project$Pwr$Tenant$displayName(tenant) + ' logo')
			]),
		_List_Nil);
};
var $author$project$Pwr$Ui$Agent$Onboarding$Layout$viewLogo = function (tenant) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-[140px]')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Route$href($author$project$Route$AgentHome),
						$elm$html$Html$Attributes$title('home')
					]),
				_List_fromArray(
					[
						$author$project$Pwr$Ui$Branding$Graphic$viewLogo(tenant)
					]))
			]));
};
var $author$project$Pwr$Ui$Agent$Onboarding$Layout$viewTitleBar = function (tenant) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex justify-between items-center'),
				$elm$html$Html$Attributes$class('px-2 sm:px-4 md:px-12 py-2'),
				$elm$html$Html$Attributes$class('bg-header')
			]),
		_List_fromArray(
			[
				$author$project$Pwr$Ui$Agent$Onboarding$Layout$viewLogo(tenant)
			]));
};
var $author$project$Pwr$Ui$Agent$Onboarding$Layout$viewOverlay = function (tenant) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fixed h-screen overflow-hidden'),
				$elm$html$Html$Attributes$class('w-full md:max-w-screen-lg'),
				$elm$html$Html$Attributes$class('hidden md:block md:bg')
			]),
		_List_fromArray(
			[
				$author$project$Pwr$Ui$Agent$Onboarding$Layout$viewTitleBar(tenant),
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(
						$author$project$Pwr$Ui$Agent$Onboarding$Layout$backgroundImage(tenant)),
						A2($elm$html$Html$Attributes$attribute, 'onerror', 'this.onerror=null;this.src=\'' + ($author$project$Pwr$Ui$Agent$Onboarding$Layout$defaultBackground + '\'')),
						$elm$html$Html$Attributes$alt('product images collage'),
						$elm$html$Html$Attributes$class('object-cover w-full h-auto')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute inset-0 bg-black bg-opacity-60')
					]),
				_List_Nil)
			]));
};
var $author$project$Pwr$Ui$Agent$Onboarding$Layout$view = F2(
	function (content, config) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('flex justify-center', config.S),
							_Utils_Tuple2('mx-auto max-w-screen-sm', !config.S)
						]))
				]),
			_List_fromArray(
				[
					config.S ? $author$project$Pwr$Ui$Agent$Onboarding$Layout$viewOverlay(config.o) : $author$project$Pwr$Ui$Agent$Onboarding$Layout$viewTitleBar(config.o),
					A3(
					$author$project$Pwr$Ui$Agent$Onboarding$Layout$viewContent,
					config.S,
					$author$project$Html$Attributes$Extra$maybe(config.aA),
					content)
				]));
	});
var $author$project$Page$Agents$AccountAccess$createAccountTitle = function (tenant) {
	var _v0 = $author$project$Pwr$Tenant$tenant_(tenant);
	if (_v0 === 4) {
		return 'Apply to join the Samsung Members Review Community';
	} else {
		return 'Create an account';
	}
};
var $author$project$Pwr$Ui$Form$Agent = 1;
var $author$project$Page$Agents$AccountAccess$BlurredEmail = {$: 6};
var $author$project$Page$Agents$AccountAccess$BlurredFirstName = {$: 4};
var $author$project$Page$Agents$AccountAccess$BlurredLastName = {$: 5};
var $author$project$Page$Agents$AccountAccess$ClickedAgreeToTerms = {$: 3};
var $author$project$Page$Agents$AccountAccess$ClickedCreateAccount = {$: 0};
var $author$project$Page$Agents$AccountAccess$ClickedLogin = {$: 18};
var $author$project$Page$Agents$AccountAccess$EnteredCreateEmail = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Agents$AccountAccess$EnteredFirstName = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Agents$AccountAccess$EnteredLastName = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pwr$Ui$ButtonWithSpinner$Submit = {$: 1};
var $author$project$Page$Agents$AccountAccess$createAccountSubheading = function (tenant) {
	var _v0 = $author$project$Pwr$Tenant$tenant_(tenant);
	if (_v0 === 4) {
		return 'Register below to apply to become a part of the Samsung Members Review Community. Successful applicants will receive exclusive invitations to join Samsung product sampling and review campaigns.';
	} else {
		return 'Sign up to receive free products from your favorite brands and share your opinion.';
	}
};
var $author$project$Pwr$Ui$Form$Enabled = {$: 0};
var $author$project$Pwr$Ui$Form$Field = $elm$core$Basics$identity;
var $author$project$Pwr$Ui$Form$Input = {$: 0};
var $author$project$Pwr$Ui$Form$Pwr = 0;
var $author$project$Pwr$Ui$Form$emailField = function (onChange) {
	return {ag: $author$project$Pwr$Ui$Form$Input, bP: '', ak: '', L: '', aD: '', O: $elm$core$Maybe$Nothing, P: $elm$core$Maybe$Nothing, D: $elm$core$Maybe$Nothing, Q: onChange, R: $elm$core$Maybe$Nothing, E: $elm$core$Maybe$Nothing, F: $elm$core$Dict$empty, al: _List_Nil, U: '', G: '', X: false, e: $author$project$Pwr$Ui$Form$Enabled, z: 0, aa: $elm$core$Maybe$Nothing, ab: $elm$core$Basics$identity, ba: 'email', dF: ''};
};
var $author$project$Pwr$Ui$Form$Error = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pwr$Ui$Form$error = F2(
	function (message, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				e: $author$project$Pwr$Ui$Form$Error(message)
			});
	});
var $author$project$Page$Agents$AccountAccess$errorToString = function (error) {
	switch (error) {
		case 0:
			return 'Missing first name';
		case 1:
			return 'Missing last name';
		case 2:
			return 'Invalid email format';
		default:
			return 'Must agree to terms';
	}
};
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $pzp1997$assoc_list$AssocList$get = F2(
	function (targetKey, _v0) {
		get:
		while (true) {
			var alist = _v0;
			if (!alist.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = alist.a;
				var key = _v2.a;
				var value = _v2.b;
				var rest = alist.b;
				if (_Utils_eq(key, targetKey)) {
					return $elm$core$Maybe$Just(value);
				} else {
					var $temp$targetKey = targetKey,
						$temp$_v0 = rest;
					targetKey = $temp$targetKey;
					_v0 = $temp$_v0;
					continue get;
				}
			}
		}
	});
var $pzp1997$assoc_list$AssocList$member = F2(
	function (targetKey, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$get, targetKey, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $erlandsona$assoc_set$AssocSet$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($pzp1997$assoc_list$AssocList$member, key, dict);
	});
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Page$Agents$AccountAccess$postSignUpNote = function (tenant) {
	var _v0 = $author$project$Pwr$Tenant$tenant_(tenant);
	if (_v0 === 4) {
		return 'After providing your details above, you will receive a link to apply to join the Samsung Members Review Community.';
	} else {
		return 'After signing up, you will receive a link to complete creating your account.';
	}
};
var $author$project$Page$Agents$AccountAccess$registerTabId = 'account-access-tab-register';
var $author$project$Pwr$Ui$Form$textField = function (onChange) {
	return {ag: $author$project$Pwr$Ui$Form$Input, bP: '', ak: '', L: '', aD: '', O: $elm$core$Maybe$Nothing, P: $elm$core$Maybe$Nothing, D: $elm$core$Maybe$Nothing, Q: onChange, R: $elm$core$Maybe$Nothing, E: $elm$core$Maybe$Nothing, F: $elm$core$Dict$empty, al: _List_Nil, U: '', G: '', X: false, e: $author$project$Pwr$Ui$Form$Enabled, z: 0, aa: $elm$core$Maybe$Nothing, ab: $elm$core$Basics$identity, ba: 'text', dF: ''};
};
var $author$project$Pwr$Ui$Icon$delete = $author$project$Pwr$Ui$Icon$TwentyFour(
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z')
				]),
			_List_Nil)
		]));
var $author$project$Pwr$Ui$TextArea$Attribute = $elm$core$Basics$identity;
var $author$project$Pwr$Ui$TextArea$classList = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $elm$html$Html$Attributes$classList);
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$Pwr$Ui$TextArea$disabled = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $elm$html$Html$Attributes$disabled);
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$Html$Attributes$Extra$cond = F2(
	function (bool, attr) {
		return bool ? attr : $author$project$Html$Attributes$Extra$none;
	});
var $author$project$Pwr$Ui$Form$fieldErrorClasses = 'bg-critical-subdued text-critical border-critical focus:ring-red-500 focus:border-red-500';
var $author$project$Pwr$Ui$Form$fieldWarningClasses = 'bg-yellow-50 text-yellow-500 border-yellow-500 focus:ring-yellow-500 focus:border-yellow-500';
var $author$project$Pwr$Ui$Form$hasError = function (state) {
	if (state.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pwr$Ui$Form$hasWarning = function (state) {
	if (state.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Pwr$Ui$Form$isDisabled = function (state) {
	if (state.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Html$Events$Extra$onKeyUp = function (msgDict) {
	return A2(
		$elm$html$Html$Events$on,
		'keyup',
		A2(
			$elm$json$Json$Decode$andThen,
			function (keyCode) {
				var _v0 = A2($elm$core$Dict$get, keyCode, msgDict);
				if (!_v0.$) {
					var myMsg = _v0.a;
					return $elm$json$Json$Decode$succeed(myMsg);
				} else {
					return $elm$json$Json$Decode$fail(
						$elm$core$String$fromInt(keyCode));
				}
			},
			$elm$html$Html$Events$keyCode));
};
var $elm$html$Html$Attributes$pattern = $elm$html$Html$Attributes$stringProperty('pattern');
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Pwr$Ui$Form$styleToInputClass = function (style) {
	if (!style) {
		return '';
	} else {
		return 'text-strong font-bold hover:bg-hover';
	}
};
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Pwr$Ui$Form$fieldAttributes = function (_v0) {
	var config = _v0;
	return _List_fromArray(
		[
			$elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Pwr$Ui$Form$fieldErrorClasses,
					$author$project$Pwr$Ui$Form$hasError(config.e)),
					_Utils_Tuple2(
					$author$project$Pwr$Ui$Form$fieldWarningClasses,
					$author$project$Pwr$Ui$Form$hasWarning(config.e)),
					_Utils_Tuple2('disabled:opacity-50 disabled:cursor-not-allowed', true),
					_Utils_Tuple2(
					$author$project$Pwr$Ui$Form$styleToInputClass(config.z),
					true),
					_Utils_Tuple2(config.ak, true)
				])),
			$elm$html$Html$Attributes$autocomplete(false),
			A2(
			$author$project$Html$Attributes$Extra$cond,
			config.ba !== '',
			$elm$html$Html$Attributes$type_(config.ba)),
			A2(
			$author$project$Html$Attributes$Extra$cond,
			!$elm$core$String$isEmpty(config.L),
			A2($elm$html$Html$Attributes$attribute, 'inputmode', config.L)),
			A2(
			$author$project$Html$Attributes$Extra$cond,
			!$elm$core$String$isEmpty(config.U),
			$elm$html$Html$Attributes$pattern(config.U)),
			A2(
			$author$project$Html$Attributes$Extra$cond,
			config.G !== '',
			$elm$html$Html$Attributes$placeholder(config.G)),
			$elm$html$Html$Events$onInput(config.Q),
			$author$project$Html$Attributes$Extra$maybe(
			A2(
				$elm$core$Maybe$map,
				$elm$html$Html$Attributes$min,
				A2($elm$core$Maybe$map, $elm$core$String$fromInt, config.P))),
			$author$project$Html$Attributes$Extra$maybe(
			A2(
				$elm$core$Maybe$map,
				$elm$html$Html$Attributes$max,
				A2($elm$core$Maybe$map, $elm$core$String$fromInt, config.O))),
			$elm$html$Html$Attributes$value(
			config.ab(config.dF)),
			$elm$html$Html$Attributes$id(config.bP),
			$author$project$Html$Attributes$Extra$maybe(
			A2($elm$core$Maybe$map, $elm$html$Html$Events$onBlur, config.D)),
			$author$project$Html$Attributes$Extra$maybe(
			A2($elm$core$Maybe$map, $elm$html$Html$Events$onFocus, config.E)),
			$elm$core$Dict$isEmpty(config.F) ? $author$project$Html$Attributes$Extra$none : $author$project$Html$Events$Extra$onKeyUp(config.F),
			$elm$html$Html$Attributes$disabled(
			$author$project$Pwr$Ui$Form$isDisabled(config.e))
		]);
};
var $author$project$Pwr$Ui$TextArea$id = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $elm$html$Html$Attributes$id);
var $elm$html$Html$input = _VirtualDom_node('input');
var $author$project$Pwr$Ui$TextArea$onBlur = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $elm$html$Html$Events$onBlur);
var $author$project$Pwr$Ui$TextArea$onFocus = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $elm$html$Html$Events$onFocus);
var $author$project$Pwr$Ui$TextArea$onInput = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $elm$html$Html$Events$onInput);
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $author$project$Pwr$Ui$TextArea$rows = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $elm$html$Html$Attributes$rows);
var $author$project$Pwr$Ui$TextArea$value = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $elm$html$Html$Attributes$value);
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Pwr$Ui$TextArea$unattr = function (_v0) {
	var attr = _v0;
	return attr;
};
var $author$project$Pwr$Ui$TextArea$view = function (attrs) {
	return A3(
		$elm$html$Html$node,
		'pwr-ui-text-area',
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('block w-full')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$textarea,
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'data-gramm', 'false'),
								A2($elm$html$Html$Attributes$attribute, 'data-gramm_editor', 'false'),
								A2($elm$html$Html$Attributes$attribute, 'data-enable-grammarly', 'false'),
								$elm$html$Html$Attributes$class('h-auto resize-none overflow-y-hidden disabled:cursor-not-allowed disabled:opacity-50'),
								$elm$html$Html$Attributes$autocomplete(false)
							]),
							A2($elm$core$List$map, $author$project$Pwr$Ui$TextArea$unattr, attrs)
						])),
				_List_Nil)
			]));
};
var $author$project$Pwr$Ui$Form$viewElement = function (_v0) {
	var config = _v0;
	var _v1 = config.ag;
	switch (_v1.$) {
		case 0:
			return A2(
				$elm$html$Html$input,
				$author$project$Pwr$Ui$Form$fieldAttributes(config),
				_List_Nil);
		case 2:
			return A2(
				$elm$html$Html$input,
				$author$project$Pwr$Ui$Form$fieldAttributes(config),
				_List_Nil);
		default:
			var numRows = _v1.a;
			return $author$project$Pwr$Ui$TextArea$view(
				A2(
					$elm$core$List$append,
					function () {
						var _v3 = config.D;
						if (!_v3.$) {
							var msg = _v3.a;
							return _List_fromArray(
								[
									$author$project$Pwr$Ui$TextArea$onBlur(msg)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					A2(
						$elm$core$List$append,
						function () {
							var _v2 = config.E;
							if (!_v2.$) {
								var msg = _v2.a;
								return _List_fromArray(
									[
										$author$project$Pwr$Ui$TextArea$onFocus(msg)
									]);
							} else {
								return _List_Nil;
							}
						}(),
						_List_fromArray(
							[
								$author$project$Pwr$Ui$TextArea$id(config.bP),
								$author$project$Pwr$Ui$TextArea$onInput(config.Q),
								$author$project$Pwr$Ui$TextArea$value(
								config.ab(config.dF)),
								$author$project$Pwr$Ui$TextArea$rows(numRows),
								$author$project$Pwr$Ui$TextArea$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Pwr$Ui$Form$fieldErrorClasses,
										$author$project$Pwr$Ui$Form$hasError(config.e)),
										_Utils_Tuple2(
										$author$project$Pwr$Ui$Form$fieldWarningClasses,
										$author$project$Pwr$Ui$Form$hasWarning(config.e))
									])),
								$author$project$Pwr$Ui$TextArea$disabled(
								$author$project$Pwr$Ui$Form$isDisabled(config.e))
							]))));
	}
};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$Html$Extra$viewIf = F2(
	function (predicate, content) {
		return predicate ? content : $author$project$Html$Extra$none;
	});
var $author$project$Pwr$Ui$Icon$checkCircle = $author$project$Pwr$Ui$Icon$TwentyFour(
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z')
				]),
			_List_Nil)
		]));
var $author$project$Pwr$Ui$Form$testFieldId = function (_v0) {
	var config = _v0;
	var _v1 = config.e;
	switch (_v1.$) {
		case 2:
			return $author$project$Pwr$Test$attribute(config.bP + '-input-error');
		case 5:
			return $author$project$Pwr$Test$attribute(config.bP + '-input-success');
		case 3:
			return $author$project$Pwr$Test$attribute(config.bP + '-input-warning');
		default:
			return $author$project$Html$Attributes$Extra$none;
	}
};
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $author$project$Pwr$Ui$Icon$warningCircle = $author$project$Pwr$Ui$Icon$TwentyFour(
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('12'),
					$elm$svg$Svg$Attributes$cy('12'),
					$elm$svg$Svg$Attributes$r('12'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 13C11.45 13 11 12.55 11 12V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V12C13 12.55 12.55 13 12 13ZM13 17H11V15H13V17Z')
				]),
			_List_Nil)
		]));
var $author$project$Pwr$Ui$Form$viewStatusIcon = function (_v0) {
	var config = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ml-1.5 group relative flex items-center justify-center'),
				$author$project$Pwr$Ui$Form$testFieldId(config)
			]),
		function () {
			var _v1 = config.e;
			switch (_v1.$) {
				case 2:
					var errorMessage = _v1.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Pwr$Ui$Icon$view,
							_List_fromArray(
								[
									$author$project$Pwr$Ui$Icon$class('h-5 w-5 text-critical')
								]),
							$author$project$Pwr$Ui$Icon$error),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sr-only')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(errorMessage)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltip'),
									$elm$html$Html$Attributes$class('hidden absolute left-6 w-40 group-hover:block')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(errorMessage)
								]))
						]);
				case 3:
					var warningMessage = _v1.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Pwr$Ui$Icon$view,
							_List_fromArray(
								[
									$author$project$Pwr$Ui$Icon$class('h-5 w-5 text-yellow-500')
								]),
							$author$project$Pwr$Ui$Icon$warningCircle),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sr-only')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(warningMessage)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltip'),
									$elm$html$Html$Attributes$class('hidden absolute left-6 w-40 group-hover:block')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(warningMessage)
								]))
						]);
				case 5:
					return _List_fromArray(
						[
							A2(
							$author$project$Pwr$Ui$Icon$view,
							_List_fromArray(
								[
									$author$project$Pwr$Ui$Icon$class('h-5 w-5 text-teal-500')
								]),
							$author$project$Pwr$Ui$Icon$checkCircle)
						]);
				default:
					return _List_Nil;
			}
		}());
};
var $author$project$Html$Extra$viewUnless = F2(
	function (predicate, content) {
		return predicate ? $author$project$Html$Extra$none : content;
	});
var $author$project$Pwr$Ui$Form$viewLabel = function (_v0) {
	var config = _v0;
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				A2(
				$author$project$Html$Attributes$Extra$cond,
				!$elm$core$String$isEmpty(config.bP),
				$elm$html$Html$Attributes$for(config.bP)),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('flex items-center text-sm font-medium', true),
						_Utils_Tuple2(
						'text-critical',
						$author$project$Pwr$Ui$Form$hasError(config.e)),
						_Utils_Tuple2(
						'text-yellow-500',
						$author$project$Pwr$Ui$Form$hasWarning(config.e))
					]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(config.aD),
				A2(
				$author$project$Html$Extra$viewUnless,
				config.X,
				$elm$html$Html$text(' (optional)')),
				A2(
				$author$project$Html$Extra$viewIf,
				!config.z,
				$author$project$Pwr$Ui$Form$viewStatusIcon(config))
			]));
};
var $author$project$Html$Extra$viewMaybe = F2(
	function (toView, m) {
		if (!m.$) {
			var a = m.a;
			return toView(a);
		} else {
			return $author$project$Html$Extra$none;
		}
	});
var $author$project$Pwr$Ui$Form$toHtml = function (_v0) {
	var config = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-full text-strong'),
				$author$project$Html$Attributes$Extra$maybe(
				A2($elm$core$Maybe$map, $author$project$Pwr$Test$attribute, config.aa))
			]),
		_List_fromArray(
			[
				$author$project$Pwr$Ui$Form$viewLabel(config),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('relative mt-1 flex items-center')
					]),
				_List_fromArray(
					[
						$author$project$Pwr$Ui$Form$viewElement(config),
						A2(
						$author$project$Html$Extra$viewMaybe,
						function (onClear) {
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('absolute inset-y-0 right-0 px-2'),
										$elm$html$Html$Events$onClick(onClear)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Pwr$Ui$Icon$view,
										_List_fromArray(
											[
												$author$project$Pwr$Ui$Icon$class('w-5 h-5')
											]),
										$author$project$Pwr$Ui$Icon$delete)
									]));
						},
						config.R)
					])),
				function () {
				var _v1 = _Utils_Tuple2(config.e, config.z);
				_v1$4:
				while (true) {
					if (_v1.b === 1) {
						switch (_v1.a.$) {
							case 2:
								if (_v1.a.a === '') {
									var _v2 = _v1.b;
									return $author$project$Html$Extra$none;
								} else {
									var errorCopy = _v1.a.a;
									var _v3 = _v1.b;
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('bg-critical-subdued px-3 py-1 mt-2 text-critical rounded-sm')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(errorCopy)
											]));
								}
							case 3:
								if (_v1.a.a === '') {
									var _v4 = _v1.b;
									return $author$project$Html$Extra$none;
								} else {
									var warningCopy = _v1.a.a;
									var _v5 = _v1.b;
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('bg-yellow-100 px-3 py-1 mt-2 text-yellow-800 rounded-sm')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(warningCopy)
											]));
								}
							default:
								break _v1$4;
						}
					} else {
						break _v1$4;
					}
				}
				return $author$project$Html$Extra$none;
			}()
			]));
};
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $author$project$Pwr$Ui$Icon$spinner = $author$project$Pwr$Ui$Icon$TwentyFour(
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$stroke('currentColor'),
					$elm$svg$Svg$Attributes$cx('12'),
					$elm$svg$Svg$Attributes$cy('12'),
					$elm$svg$Svg$Attributes$r('10'),
					$elm$svg$Svg$Attributes$strokeWidth('4'),
					$elm$svg$Svg$Attributes$class('opacity-25')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'),
					$elm$svg$Svg$Attributes$class('opacity-75')
				]),
			_List_Nil)
		]));
var $author$project$Html$Extra$zeroWidthSpace = '\u200B';
var $author$project$Pwr$Ui$ButtonWithSpinner$view = function (config) {
	var buttonType = function () {
		var _v2 = config.ba;
		if (!_v2.$) {
			return 'button';
		} else {
			return 'submit';
		}
	}();
	var _v0 = config.aU ? _Utils_Tuple2(
		$author$project$Html$Attributes$Extra$none,
		_List_fromArray(
			[
				$elm$html$Html$text($author$project$Html$Extra$zeroWidthSpace),
				A2(
				$author$project$Pwr$Ui$Icon$view,
				_List_fromArray(
					[
						$author$project$Pwr$Ui$Icon$class('animate-spin inline h-5 w-5')
					]),
				$author$project$Pwr$Ui$Icon$spinner)
			])) : _Utils_Tuple2(
		function () {
			var _v1 = config.ba;
			if (!_v1.$) {
				var m = _v1.a;
				return $elm$html$Html$Events$onClick(m);
			} else {
				return $author$project$Html$Attributes$Extra$none;
			}
		}(),
		_List_fromArray(
			[
				$elm$html$Html$text(config.aD)
			]));
	var clickAttr = _v0.a;
	var content = _v0.b;
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				clickAttr,
				$elm$html$Html$Attributes$type_(buttonType),
				$elm$html$Html$Attributes$class('btn'),
				$elm$html$Html$Attributes$class(config.bd),
				$elm$html$Html$Attributes$classList(config.aM),
				$elm$html$Html$Attributes$disabled(config.aP || config.aU),
				$elm$html$Html$Attributes$id('save-button-id')
			]),
		content);
};
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $author$project$Pwr$Ui$TermsOfService$agreeToTermsWrapper = F3(
	function (hasAgreedToTerms, onClick, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex mt-6 space-x-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('agree-to-terms-checkbox'),
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$class('mt-0.5'),
							$elm$html$Html$Attributes$checked(hasAgreedToTerms),
							$elm$html$Html$Events$onInput(
							function (_v0) {
								return onClick;
							})
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('agree-to-terms-checkbox')
						]),
					content)
				]));
	});
var $author$project$Constants$communityName = function (tenant) {
	var _v0 = $author$project$Pwr$Tenant$tenant_(tenant);
	switch (_v0) {
		case 0:
			return 'BzzAgent';
		case 1:
			return 'My John Lewis';
		case 2:
			return 'BzzAgent';
		case 3:
			return 'Demo Store';
		default:
			return 'Samsung';
	}
};
var $author$project$Constants$Bzz$influencerAgreement = 'https://www.bzzagent.com/influencer-agreement';
var $author$project$Constants$Bzz$privacyNotice = 'https://bzzagent.com/privacy-policy/';
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Constants$Bzz$termsAndConds = 'https://www.bzzagent.com/terms-and-conditions';
var $author$project$Pwr$Ui$TermsOfService$viewBzzAgreeToTerms = function (tenant) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[
								'I agree to the ',
								$author$project$Constants$communityName(tenant),
								' '
							])))
				])),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href($author$project$Constants$Bzz$influencerAgreement),
					$elm$html$Html$Attributes$class('link'),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Influencer Agreement')
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[
								', which governs my participation in the',
								$author$project$Constants$communityName(tenant),
								'program, and '
							])))
				])),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href($author$project$Constants$Bzz$termsAndConds),
					$elm$html$Html$Attributes$class('link'),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Terms of Use')
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[
								'. I also agree',
								$author$project$Constants$communityName(tenant),
								'may process my information, including any sensitive information I provide, in order to match me to campaigns and as set forth in the '
							])))
				])),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href($author$project$Constants$Bzz$privacyNotice),
					$elm$html$Html$Attributes$class('link'),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Privacy Policy')
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('.')
				]))
		]);
};
var $author$project$Constants$Jlp$privacyNotice = 'https://www.johnlewis.com/customer-services/shopping-with-us/privacy-notice';
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$Constants$Jlp$termsAndConds = 'https://www.johnlewis.com/customer-services/shopping-with-us/terms-and-conditions';
var $author$project$Pwr$Ui$TermsOfService$viewJlpAgreeToTerms = _List_fromArray(
	[
		A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('I agree to the ')
			])),
		A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href($author$project$Constants$Jlp$termsAndConds),
				$elm$html$Html$Attributes$class('link'),
				$elm$html$Html$Attributes$target('_blank'),
				$elm$html$Html$Attributes$rel('noopener')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Terms & Conditions')
			])),
		A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(' for the My John Lewis Review Panel. I also agree John Lewis may process my information in order to match me to product trials and as set forth in the ')
			])),
		A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href($author$project$Constants$Jlp$privacyNotice),
				$elm$html$Html$Attributes$class('link'),
				$elm$html$Html$Attributes$target('_blank'),
				$elm$html$Html$Attributes$rel('noopener')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Privacy Policy')
			])),
		A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('.')
			]))
	]);
var $author$project$Constants$Samsung$privacyNotice = 'https://www.samsung.com/uk/info/privacy/';
var $author$project$Constants$Samsung$termsAndConds = 'https://eu.community.samsung.com/t5/contest-t-cs/stretchyourstyle-challenge-terms-amp-conditions/m-p/14598737#M49';
var $author$project$Pwr$Ui$TermsOfService$viewSamsungAgreeToTerms = _List_fromArray(
	[
		A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('I agree to the ')
			])),
		A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href($author$project$Constants$Samsung$termsAndConds),
				$elm$html$Html$Attributes$class('link'),
				$elm$html$Html$Attributes$target('_blank'),
				$elm$html$Html$Attributes$rel('noopener')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Terms & Conditions')
			])),
		A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(' for Samsung. I also agree Samsung may process my information in order to match me as set forth in the ')
			])),
		A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href($author$project$Constants$Samsung$privacyNotice),
				$elm$html$Html$Attributes$class('link'),
				$elm$html$Html$Attributes$target('_blank'),
				$elm$html$Html$Attributes$rel('noopener')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Privacy Policy')
			])),
		A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('.')
			]))
	]);
var $author$project$Pwr$Ui$TermsOfService$view = F3(
	function (tenant, hasAgreedToTerms, onClick) {
		return A3(
			$author$project$Pwr$Ui$TermsOfService$agreeToTermsWrapper,
			hasAgreedToTerms,
			onClick,
			function () {
				var _v0 = $author$project$Pwr$Tenant$tenant_(tenant);
				switch (_v0) {
					case 0:
						return $author$project$Pwr$Ui$TermsOfService$viewBzzAgreeToTerms(tenant);
					case 1:
						return $author$project$Pwr$Ui$TermsOfService$viewJlpAgreeToTerms;
					case 2:
						return $author$project$Pwr$Ui$TermsOfService$viewBzzAgreeToTerms(tenant);
					case 3:
						return $author$project$Pwr$Ui$TermsOfService$viewBzzAgreeToTerms(tenant);
					default:
						return $author$project$Pwr$Ui$TermsOfService$viewSamsungAgreeToTerms;
				}
			}());
	});
var $author$project$Page$Agents$AccountAccess$tabPanelId = 'account-access-tabpanel';
var $author$project$Page$Agents$AccountAccess$ClickedRegister = {$: 17};
var $author$project$Page$Agents$AccountAccess$loginTabId = 'account-access-tab-login';
var $author$project$Page$Agents$AccountAccess$loginTabLabel = function (tenant) {
	var _v0 = $author$project$Pwr$Tenant$tenant_(tenant);
	if (_v0 === 4) {
		return 'Log in';
	} else {
		return 'Login';
	}
};
var $author$project$Page$Agents$AccountAccess$registerTabLabel = function (tenant) {
	var _v0 = $author$project$Pwr$Tenant$tenant_(tenant);
	if (_v0 === 4) {
		return 'Join';
	} else {
		return 'Register';
	}
};
var $author$project$Page$Agents$AccountAccess$viewTab = F4(
	function (tabId, title, onClick_, isSelected) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(onClick_),
					$elm$html$Html$Attributes$id(tabId),
					A2($elm$html$Html$Attributes$attribute, 'role', 'tab'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'aria-selected',
					isSelected ? 'true' : 'false'),
					isSelected ? A2($elm$html$Html$Attributes$attribute, 'aria-controls', $author$project$Page$Agents$AccountAccess$tabPanelId) : $author$project$Html$Attributes$Extra$none,
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('w-1/2 py-4 px-1 text-center text-lg font-brandon border-b-2 focus:outline-none', true),
							_Utils_Tuple2('border-b-2 border-default text-subdued focus:text focus:border-hover hover:text hover:border-hover', !isSelected),
							_Utils_Tuple2('border-primary text-primary font-semibold pointer-events-none cursor-default', isSelected)
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(title)
				]));
	});
var $author$project$Page$Agents$AccountAccess$viewTabs = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex w-full mt-2 mb-6'),
				A2($elm$html$Html$Attributes$attribute, 'role', 'tablist'),
				A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Tabs')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$Page$Agents$AccountAccess$viewTab,
				$author$project$Page$Agents$AccountAccess$registerTabId,
				$author$project$Page$Agents$AccountAccess$registerTabLabel(model.o),
				$author$project$Page$Agents$AccountAccess$ClickedRegister,
				!$author$project$SelectList$selected(model.f)),
				A4(
				$author$project$Page$Agents$AccountAccess$viewTab,
				$author$project$Page$Agents$AccountAccess$loginTabId,
				$author$project$Page$Agents$AccountAccess$loginTabLabel(model.o),
				$author$project$Page$Agents$AccountAccess$ClickedLogin,
				$author$project$SelectList$selected(model.f) === 4)
			]));
};
var $author$project$Page$Agents$AccountAccess$viewTabPanel = F3(
	function (model, activeTabId, body) {
		return $author$project$Pwr$Tenant$communityClosed(model.o) ? A2($elm$html$Html$div, _List_Nil, body) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$Agents$AccountAccess$viewTabs(model),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'role', 'tabpanel'),
							$elm$html$Html$Attributes$id($author$project$Page$Agents$AccountAccess$tabPanelId),
							A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', activeTabId)
						]),
					body)
				]));
	});
var $author$project$Pwr$Ui$Form$withId = F2(
	function (id, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{bP: id});
	});
var $author$project$Pwr$Ui$Form$withLabel = F2(
	function (label, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{aD: label});
	});
var $author$project$Pwr$Ui$Form$withOnBlur = F2(
	function (onBlur, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				D: $elm$core$Maybe$Just(onBlur)
			});
	});
var $author$project$Pwr$Ui$Form$withRequired = F2(
	function (required, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{X: required});
	});
var $author$project$Pwr$Ui$Form$withStyle = F2(
	function (style, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{z: style});
	});
var $author$project$Pwr$Ui$Form$withValue = F2(
	function (value, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{dF: value});
	});
var $author$project$Page$Agents$AccountAccess$viewCreate = function (model) {
	var isFormValid = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return true;
			},
			$elm$core$Result$toMaybe(
				A2($rtfeldman$elm_validate$Validate$validate, $author$project$Page$Agents$AccountAccess$validateSignUp, model.l))));
	var fieldError = F2(
		function (errorToFind, field) {
			return A2($erlandsona$assoc_set$AssocSet$member, errorToFind, model.g) ? A2(
				$author$project$Pwr$Ui$Form$error,
				$author$project$Page$Agents$AccountAccess$errorToString(errorToFind),
				field) : field;
		});
	return A3(
		$author$project$Page$Agents$AccountAccess$viewTabPanel,
		model,
		$author$project$Page$Agents$AccountAccess$registerTabId,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center mb-4')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Page$Agents$AccountAccess$createAccountSubheading(model.o))
					])),
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Events$onSubmit($author$project$Page$Agents$AccountAccess$ClickedCreateAccount)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('space-y-5')
							]),
						_List_fromArray(
							[
								$author$project$Pwr$Ui$Form$toHtml(
								A2(
									fieldError,
									0,
									A2(
										$author$project$Pwr$Ui$Form$withOnBlur,
										$author$project$Page$Agents$AccountAccess$BlurredFirstName,
										A2(
											$author$project$Pwr$Ui$Form$withRequired,
											true,
											A2(
												$author$project$Pwr$Ui$Form$withValue,
												model.l.J,
												A2(
													$author$project$Pwr$Ui$Form$withLabel,
													'First Name',
													A2(
														$author$project$Pwr$Ui$Form$withId,
														'signup-first-name',
														A2(
															$author$project$Pwr$Ui$Form$withStyle,
															1,
															$author$project$Pwr$Ui$Form$textField($author$project$Page$Agents$AccountAccess$EnteredFirstName))))))))),
								$author$project$Pwr$Ui$Form$toHtml(
								A2(
									fieldError,
									1,
									A2(
										$author$project$Pwr$Ui$Form$withOnBlur,
										$author$project$Page$Agents$AccountAccess$BlurredLastName,
										A2(
											$author$project$Pwr$Ui$Form$withRequired,
											true,
											A2(
												$author$project$Pwr$Ui$Form$withValue,
												model.l.M,
												A2(
													$author$project$Pwr$Ui$Form$withLabel,
													'Last Name',
													A2(
														$author$project$Pwr$Ui$Form$withId,
														'signup-last-name',
														A2(
															$author$project$Pwr$Ui$Form$withStyle,
															1,
															$author$project$Pwr$Ui$Form$textField($author$project$Page$Agents$AccountAccess$EnteredLastName))))))))),
								$author$project$Pwr$Ui$Form$toHtml(
								A2(
									fieldError,
									2,
									A2(
										$author$project$Pwr$Ui$Form$withOnBlur,
										$author$project$Page$Agents$AccountAccess$BlurredEmail,
										A2(
											$author$project$Pwr$Ui$Form$withRequired,
											true,
											A2(
												$author$project$Pwr$Ui$Form$withValue,
												model.l.B,
												A2(
													$author$project$Pwr$Ui$Form$withLabel,
													'Email',
													A2(
														$author$project$Pwr$Ui$Form$withId,
														'signup-email',
														A2(
															$author$project$Pwr$Ui$Form$withStyle,
															1,
															$author$project$Pwr$Ui$Form$emailField($author$project$Page$Agents$AccountAccess$EnteredCreateEmail)))))))))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-6')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Page$Agents$AccountAccess$postSignUpNote(model.o))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-sm')
							]),
						_List_fromArray(
							[
								A3($author$project$Pwr$Ui$TermsOfService$view, model.o, model.l.ai, $author$project$Page$Agents$AccountAccess$ClickedAgreeToTerms)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-center')
							]),
						_List_fromArray(
							[
								$author$project$Pwr$Ui$ButtonWithSpinner$view(
								{
									aM: _List_fromArray(
										[
											_Utils_Tuple2('btn btn-primary py-4 rounded-lg text-xl mt-6', true)
										]),
									aP: !isFormValid,
									aU: model._,
									aD: 'Register',
									ba: $author$project$Pwr$Ui$ButtonWithSpinner$Submit,
									bd: 'w-full'
								})
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-center pt-6')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Already have an account? ')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Page$Agents$AccountAccess$ClickedLogin),
										$elm$html$Html$Attributes$class('btn btn-transparent')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Login')
									]))
							]))
					]))
			]));
};
var $author$project$Pwr$Ui$ButtonWithSpinner$Button = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Agents$AccountAccess$ClickedResendEmail = {$: 2};
var $author$project$Constants$supportEmailAddress = function (tenant) {
	var _v0 = $author$project$Pwr$Tenant$tenant_(tenant);
	switch (_v0) {
		case 0:
			return 'support@bzzagent.com';
		case 1:
			return 'myjlreviewpanel@johnlewis.co.uk';
		case 2:
			return 'support@bzzagent.com';
		case 3:
			return 'ruby-team@powerreviews.com';
		default:
			return 'samsung-placeholder@email.invalid';
	}
};
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$Attributes$opacity = _VirtualDom_attribute('opacity');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Pwr$Ui$Agent$Graphic$viewMissingMail = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('260'),
			$elm$svg$Svg$Attributes$height('248'),
			$elm$svg$Svg$Attributes$viewBox('0 0 260 248'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$clipPath('url(#clip0_1657_2013)')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M0.499822 110.787C0.461247 136.938 9.72355 162.253 26.6354 182.219C27.2496 182.947 27.8752 183.664 28.5124 184.377C36.0106 192.799 44.7452 200.036 54.4177 205.841C56.6363 207.171 58.9035 208.424 61.2193 209.601C61.4534 209.72 61.6914 209.839 61.9256 209.954C62.2058 210.096 62.4898 210.234 62.7738 210.372C68.6341 213.236 74.7382 215.574 81.0139 217.356C81.6664 217.54 82.3202 217.719 82.9753 217.893C91.2307 220.075 99.711 221.295 108.247 221.531C108.693 221.543 109.13 221.55 109.552 221.558C109.702 221.562 109.848 221.566 109.994 221.566C110.474 221.569 110.949 221.573 111.429 221.573C120.425 221.58 129.388 220.495 138.121 218.342C138.997 218.127 139.868 217.901 140.735 217.663C145.305 216.417 149.788 214.877 154.158 213.051C156.461 212.093 158.723 211.059 160.945 209.95C161.447 209.697 161.95 209.444 162.445 209.183C162.656 209.08 162.864 208.969 163.071 208.861C174.909 202.621 185.525 194.303 194.411 184.304C195.026 183.618 195.628 182.921 196.223 182.219C212.529 162.933 259.235 134.267 259.235 107.05C259.235 70.448 204.587 41.7309 177.189 21.5593C176.559 21.0954 175.926 20.6354 175.285 20.1869C175.158 20.0988 175.031 20.0106 174.905 19.9224C163.642 12.0432 151 6.34154 137.634 3.11275C136.874 2.92492 136.114 2.74858 135.346 2.58374C120.869 -0.578972 105.907 -0.840872 91.3276 1.81322C90.5638 1.95505 89.8 2.10072 89.04 2.25789C75.7935 4.9714 63.1597 10.0951 51.7692 17.3732C51.5159 17.5342 51.2625 17.6952 51.0092 17.8639C50.4987 18.1935 49.9882 18.5309 49.4854 18.8721C34.3964 29.0032 22.0354 42.6869 13.4926 58.7162C4.94978 74.7456 0.487691 92.6281 0.499822 110.787Z'),
							$elm$svg$Svg$Attributes$fill('#EFF0F0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M139.515 167.219C139.498 167.454 139.573 167.686 139.726 167.866C139.879 168.045 140.096 168.158 140.332 168.179L174.905 171.244L175.285 171.278V20.1869C175.158 20.0988 175.032 20.0106 174.905 19.9224C167.516 14.7606 159.523 10.52 151.103 7.29504L149.291 32.2508L149.126 34.5355L147.334 59.2842L146.781 66.8975L139.515 167.219Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M51.7694 17.3732C51.516 17.5342 51.2627 17.6952 51.0094 17.8638V171.278L51.7694 171.209L86.8408 168.1L86.7755 167.219L79.5094 66.8975L78.9567 59.2842L77.1642 34.5355L76.9991 32.2508L75.0991 6.07983C66.9055 8.91634 59.075 12.7069 51.7694 17.3732Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M51.0094 17.8638C50.4989 18.1935 49.9884 18.5309 49.4855 18.872V173.371C49.4855 177.232 51.7771 180.467 54.8401 181.291C55.3406 181.427 55.8569 181.495 56.3755 181.494H170.299C170.816 181.495 171.331 181.427 171.83 181.291C172.969 180.976 174.001 180.359 174.817 179.505C176.372 177.844 177.223 175.645 177.189 173.371V21.5593C176.559 21.0954 175.926 20.6354 175.285 20.1869C175.158 20.0987 175.032 20.0106 174.905 19.9224V173.371C174.906 173.869 174.847 174.364 174.728 174.847C174.187 177.128 172.402 178.8 170.299 178.8H56.3755C53.8345 178.8 51.7694 176.365 51.7694 173.371V17.3732C51.516 17.5342 51.2627 17.6952 51.0094 17.8638Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M176.047 32.2523H50.6265V34.5367H176.047V32.2523Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M137.634 3.11275C136.874 2.92492 136.114 2.74858 135.347 2.58374V64.6127H137.634V3.11275Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M91.3278 1.8132C90.564 1.95504 89.8002 2.10071 89.0402 2.25788V64.6127H91.3278V1.8132Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M26.0368 177.496C26.0363 178.807 26.2878 180.106 26.7776 181.322C26.9658 181.794 27.1904 182.25 27.4494 182.687C27.7839 183.256 28.172 183.793 28.6085 184.289C29.5728 185.387 30.7606 186.266 32.0924 186.868C33.4242 187.47 34.8694 187.782 36.3314 187.781H186.531C189.262 187.781 191.88 186.698 193.811 184.77C195.741 182.842 196.826 180.227 196.826 177.5C196.826 174.773 195.741 172.158 193.811 170.23C191.88 168.302 189.262 167.219 186.531 167.219H36.3314C33.6026 167.221 30.9863 168.305 29.0564 170.232C27.1264 172.158 26.0405 174.771 26.0368 177.496Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M50.6265 66.8983L175.284 66.8983V59.2838L50.6265 59.2838V66.8983Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M118.293 61.1874H107.618C107.618 60.0767 108.06 59.0115 108.847 58.2261C109.633 57.4407 110.7 56.9995 111.812 56.9995H114.099C115.211 56.9995 116.278 57.4407 117.064 58.2261C117.851 59.0115 118.293 60.0767 118.293 61.1874Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M222.187 138.292H190.343C189.934 138.292 189.542 138.129 189.253 137.84C188.963 137.552 188.801 137.16 188.8 136.751V99.9654C188.8 99.1957 199.106 92.8312 203.537 90.1305C204.357 89.6222 205.302 89.3529 206.266 89.3531C207.231 89.3533 208.176 89.623 208.995 90.1317C213.424 92.8312 223.73 99.1957 223.73 99.9654V136.751C223.729 137.16 223.566 137.552 223.277 137.84C222.988 138.129 222.596 138.292 222.187 138.292Z'),
							$elm$svg$Svg$Attributes$fill('#B1B6B9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M225.622 93.7323L219.765 81.8065C219.674 81.6227 219.54 81.4638 219.374 81.3436C219.208 81.2233 219.016 81.1454 218.813 81.1165C218.813 81.1165 218.813 81.1126 218.809 81.1165C218.67 81.0973 218.528 81.1012 218.39 81.128C218.282 81.151 218.176 81.187 218.076 81.2353L198.788 90.6809L198.761 90.6962C198.564 90.7976 198.397 90.9492 198.277 91.1356C198.157 91.322 198.088 91.5367 198.078 91.7581C198.067 91.9688 198.111 92.1786 198.204 92.3676L201.386 98.8461L202.496 101.108L203.44 103.025H209.508L213.424 101.108L225.039 95.419C225.34 95.2726 225.571 95.0127 225.68 94.6964C225.789 94.38 225.769 94.0333 225.622 93.7323Z'),
							$elm$svg$Svg$Attributes$fill('white')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M225.622 93.7323L219.765 81.8065C219.674 81.6227 219.54 81.4638 219.374 81.3436C219.208 81.2233 219.016 81.1454 218.813 81.1165C218.813 81.1165 218.813 81.1126 218.809 81.1165C218.67 81.0973 218.528 81.1012 218.39 81.128C218.282 81.151 218.176 81.187 218.076 81.2353L198.788 90.6809L198.761 90.6962C198.564 90.7976 198.397 90.9492 198.277 91.1356C198.157 91.322 198.088 91.5367 198.078 91.7581C198.067 91.9688 198.111 92.1786 198.204 92.3676L201.386 98.8461L202.496 101.108L203.44 103.025H209.508L213.424 101.108L225.039 95.419C225.34 95.2726 225.571 95.0127 225.68 94.6964C225.789 94.38 225.769 94.0333 225.622 93.7323ZM223.864 94.6984C221.807 95.7449 216.322 98.4973 210.99 101.108C210.921 101.142 210.848 101.177 210.779 101.211C210.23 101.484 209.973 101.606 209.877 101.652C209.965 101.602 210.157 101.503 210.188 101.484C210.176 101.48 210.007 101.556 209.485 101.802C208.591 102.223 207.596 102.381 206.615 102.258C205.634 102.136 204.709 101.736 203.947 101.108C203.392 100.649 202.941 100.078 202.622 99.4327L202.127 98.4206L199.306 92.6781L198.968 91.9919C198.944 91.9431 198.93 91.8901 198.927 91.8359C198.924 91.7817 198.931 91.7274 198.949 91.6761C198.967 91.6248 198.995 91.5776 199.031 91.537C199.067 91.4965 199.111 91.4635 199.16 91.4399L199.218 91.4131L218.448 81.9905C218.497 81.9666 218.55 81.9525 218.604 81.9492C218.659 81.9459 218.713 81.9534 218.764 81.9712C218.816 81.989 218.863 82.0169 218.904 82.0531C218.944 82.0893 218.977 82.1331 219.001 82.1822L219.481 83.1635L224.386 93.142C224.519 93.4182 224.539 93.7354 224.441 94.026C224.344 94.3166 224.137 94.5579 223.864 94.6984Z'),
							$elm$svg$Svg$Attributes$fill('#6B7276')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M205.069 97.0468L219.764 89.8484C219.894 89.7849 220.001 89.6829 220.071 89.5565C220.141 89.4301 220.17 89.2853 220.154 89.1418L219.318 81.7063C219.308 81.6152 219.279 81.527 219.235 81.4468C219.19 81.3666 219.13 81.296 219.058 81.2391C218.986 81.1822 218.903 81.14 218.815 81.1151C218.727 81.0901 218.634 81.0828 218.543 81.0936C218.464 81.1028 218.386 81.1255 218.314 81.1605L198.588 90.78L198.588 90.7804C198.483 90.8307 198.393 90.9062 198.325 91C198.257 91.0938 198.214 91.2031 198.199 91.3178C198.184 91.4326 198.198 91.5493 198.239 91.6574C198.281 91.7654 198.349 91.8614 198.437 91.9368L204.303 96.9512C204.408 97.0401 204.536 97.0966 204.672 97.1136C204.808 97.1306 204.946 97.1074 205.069 97.0468Z'),
							$elm$svg$Svg$Attributes$class('fill-primary')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M212.945 95.1232C213.813 94.6984 214.173 93.6558 213.75 92.7946C213.327 91.9333 212.281 91.5795 211.414 92.0043C210.547 92.4291 210.186 93.4716 210.609 94.3329C211.032 95.1942 212.078 95.548 212.945 95.1232Z'),
							$elm$svg$Svg$Attributes$fill('#303436')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M202.3 98.2941C201.862 98.6555 201.349 98.9165 200.799 99.0587C200.248 99.201 199.673 99.2209 199.114 99.1172C198.555 99.0134 198.026 98.7885 197.563 98.4584C197.101 98.1282 196.716 97.7007 196.437 97.2061L179.221 103.374L160.772 98.944L164.111 91.1834L178.049 95.6738L198.14 91.7449C199.003 91.3314 199.988 91.2486 200.908 91.5119C201.829 91.7753 202.62 92.3667 203.133 93.1739C203.646 93.9812 203.844 94.9483 203.691 95.892C203.537 96.8357 203.043 97.6904 202.3 98.2941Z'),
							$elm$svg$Svg$Attributes$fill('#FFB6B6')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M148.766 95.3119C152.121 96.256 170.359 102.767 175.197 102.8C175.347 103.46 175.713 104.052 176.237 104.482C176.761 104.912 177.413 105.156 178.091 105.175L179.283 95.2021C177.79 93.4839 176.562 94.3819 175.983 95.0633L170.174 91.7826L148.777 81.7446C147.85 81.3095 146.823 81.1294 145.803 81.2227C144.782 81.3161 143.805 81.6796 142.972 82.2758C142.262 82.7857 141.677 83.4502 141.262 84.2191C140.847 84.9879 140.613 85.841 140.577 86.7137C140.54 87.5864 140.703 88.4559 141.053 89.2565C141.403 90.0571 141.93 90.7677 142.596 91.3347C144.677 93.1205 146.993 94.8127 148.766 95.3119Z'),
							$elm$svg$Svg$Attributes$class('fill-accent')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M95.2847 160.428C95.5907 162.679 97.123 164.711 99.0938 166.038C99.5633 166.355 100.059 166.631 100.575 166.865C101.143 167.121 101.728 167.335 102.327 167.507C104.953 168.273 107.79 168.306 110.551 168.322C113.343 168.339 116.134 168.357 118.924 168.375C121.124 168.388 123.396 168.388 125.428 167.545C125.458 167.534 125.488 167.521 125.517 167.507C127.513 166.646 129.214 164.754 129.166 162.59C129.146 161.828 128.93 161.083 128.538 160.428C128.279 159.988 127.968 159.581 127.61 159.216C126.504 158.07 124.969 157.172 123.531 156.448C121.16 155.259 118.48 153.716 117.787 151.272C117.714 151.015 117.664 150.751 117.639 150.485C117.476 148.805 118.294 147.259 119.337 145.876C119.439 145.739 119.546 145.601 119.656 145.464C119.89 145.171 120.133 144.883 120.372 144.608C120.474 144.491 120.576 144.372 120.681 144.252C121.644 143.137 122.616 141.945 123.123 140.613C123.342 140.056 123.463 139.465 123.483 138.867C123.539 136.705 121.119 134.528 119.289 135.549C118.391 135.462 117.494 135.373 116.596 135.281C115.495 135.172 114.399 135.062 113.3 134.95H113.297C113.05 134.93 112.808 134.905 112.566 134.879C110.279 134.652 107.993 134.424 105.71 134.194C104.695 134.095 103.502 134.057 102.842 134.836C102.123 135.686 102.495 137.031 103.206 137.889C103.917 138.744 104.904 139.35 105.572 140.236C105.978 140.813 106.261 141.468 106.402 142.159C106.543 142.85 106.539 143.562 106.391 144.252C106.319 144.664 106.211 145.07 106.069 145.464C105.82 146.167 105.474 146.833 105.042 147.442C103.543 149.54 101.322 150.987 99.3512 152.649C97.3779 154.315 95.5321 156.428 95.2618 158.99C95.2541 159.063 95.2465 159.14 95.2439 159.216C95.2153 159.62 95.229 160.027 95.2847 160.428Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M111.318 137.113C113.308 135.15 115.002 132.91 116.349 130.463C117.692 128.028 118.684 125.416 119.296 122.704C119.915 119.951 120.121 117.122 119.905 114.309C119.457 108.581 117.337 103.109 113.808 98.5703C113.593 98.2942 113.372 98.0223 113.146 97.7546C112.894 97.4553 112.467 97.8864 112.717 98.1836C116.318 102.496 118.574 107.768 119.206 113.348C119.663 117.612 119.153 121.924 117.713 125.964C116.273 130.004 113.941 133.668 110.889 136.684C110.61 136.959 111.04 137.388 111.318 137.113Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M114.053 99.0854C113.807 98.9935 113.566 98.8886 113.332 98.771C113.32 98.7893 113.308 98.8079 113.296 98.8261L114.053 99.0854Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M115.726 93.4486C115.593 92.0172 114.895 90.6161 113.566 89.9495C112.863 89.5581 112.038 89.444 111.255 89.6299C110.472 89.8158 109.787 90.2881 109.335 90.9536C109.273 91.0639 109.248 91.1914 109.264 91.3169C109.281 91.4425 109.337 91.5595 109.425 91.6504C109.622 91.8923 109.82 92.1327 110.016 92.3742C110.143 92.5298 110.37 92.715 110.337 92.9419C110.288 93.2702 109.909 93.2435 109.611 93.1978C109.552 93.1771 109.489 93.1671 109.426 93.1684C109.405 93.1651 109.381 93.1611 109.363 93.159C109.211 93.1601 109.065 93.221 108.957 93.3286C108.85 93.4362 108.789 93.5819 108.788 93.7341C108.787 93.7848 108.794 93.8353 108.808 93.8841L108.808 93.8869C109.132 95.4398 109.939 96.8507 111.114 97.9177C111.654 98.4292 112.264 98.8634 112.924 99.208C112.992 99.2597 113.07 99.2971 113.153 99.3177C113.236 99.3384 113.323 99.342 113.407 99.3282C113.492 99.3144 113.573 99.2836 113.645 99.2376C113.717 99.1917 113.779 99.1315 113.828 99.0608C114.07 98.719 114.29 98.3619 114.487 97.9917C115.273 96.6191 115.875 95.0568 115.726 93.4486Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M125.275 96.505C124.777 96.4282 124.28 96.351 123.782 96.2736C124.265 95.7958 124.807 95.3814 125.395 95.0403C125.482 94.9905 125.555 94.9182 125.605 94.8309C125.655 94.7436 125.681 94.6444 125.68 94.5438C125.559 93.4449 125.079 92.4615 124.044 91.9542C123.579 91.7199 123.061 91.6099 122.54 91.6349C122.02 91.6598 121.515 91.819 121.074 92.0968C120.552 92.5087 120.096 92.9973 119.72 93.5459C119.225 94.1539 118.726 94.7607 118.267 95.3972C117.344 96.6024 116.74 98.0198 116.509 99.5191C116.298 101.178 116.609 102.861 117.399 104.335C117.464 105.182 117.529 106.029 117.594 106.875C117.596 106.976 117.624 107.073 117.676 107.16C117.727 107.246 117.8 107.317 117.887 107.367C117.974 107.417 118.072 107.444 118.173 107.445C118.273 107.445 118.372 107.42 118.46 107.372C120.44 106.402 122.141 104.948 123.407 103.145C124.672 101.342 125.46 99.2486 125.698 97.0595C125.698 96.9335 125.657 96.8109 125.581 96.7106C125.504 96.6104 125.397 96.5381 125.275 96.505Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M118.672 122.828C118.871 122.838 119.069 122.843 119.266 122.84C120.962 122.83 122.639 122.473 124.193 121.792C125.746 121.111 127.145 120.121 128.301 118.881C129.238 117.857 129.991 116.679 130.527 115.4C130.509 115.398 130.494 115.395 130.476 115.393C129.65 115.265 128.821 115.135 127.995 115.008C128.873 113.866 130.039 112.979 131.373 112.436C131.554 111.286 131.568 110.115 131.414 108.961C129.548 111.998 125.186 112.243 122.43 114.504C121.115 115.598 120.219 117.112 119.893 118.789C119.812 119.204 119.768 119.625 119.763 120.047C119.76 120.149 119.76 120.248 119.763 120.348L119.702 120.485L118.672 122.828Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M116.468 122.354C115.848 120.88 115.368 119.113 113.657 118.61C112.922 118.399 112.134 118.471 111.451 118.814C110.768 119.157 110.239 119.744 109.971 120.459C109.944 120.558 109.944 120.661 109.97 120.759C109.996 120.857 110.047 120.947 110.119 121.019C110.31 121.254 110.501 121.488 110.692 121.723C110.456 121.734 110.219 121.736 109.98 121.728C109.855 121.729 109.732 121.771 109.632 121.847C109.532 121.923 109.459 122.029 109.425 122.15C109.215 123.011 109.094 123.892 109.062 124.777C109.003 125.102 109.061 125.436 109.226 125.722C109.486 126.081 109.766 126.424 110.065 126.751C110.36 127.112 110.654 127.473 110.948 127.835C110.662 127.847 110.375 127.846 110.087 127.831C109.999 127.832 109.912 127.853 109.833 127.893C109.754 127.933 109.685 127.99 109.632 128.06C109.578 128.13 109.541 128.212 109.524 128.298C109.507 128.385 109.51 128.474 109.532 128.559C110.226 130.981 111.595 133.156 113.479 134.83C113.551 134.899 113.64 134.948 113.737 134.973C113.833 134.998 113.935 134.997 114.031 134.972C114.128 134.946 114.216 134.897 114.288 134.827C114.36 134.758 114.413 134.672 114.441 134.576C114.473 134.486 114.515 134.394 114.538 134.302C114.542 134.287 114.547 134.273 114.552 134.26C114.537 134.285 114.515 134.318 114.488 134.358C114.524 134.303 114.556 134.245 114.582 134.184C114.634 134.064 114.672 133.935 114.716 133.812C114.899 133.308 115.081 132.804 115.263 132.299C115.284 132.243 115.302 132.184 115.325 132.128C115.343 132.127 115.36 132.123 115.376 132.114C115.537 132.04 115.715 131.729 115.828 131.585C115.986 131.384 116.136 131.178 116.274 130.963C116.787 130.157 117.15 129.266 117.348 128.333C117.796 126.248 117.279 124.281 116.468 122.354Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M114.552 134.26C114.583 134.181 114.626 134.14 114.552 134.26V134.26Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M9.66323 241.236L12.6226 236.486L13.2137 239.2C13.3174 239.675 13.421 240.158 13.517 240.638C14.3576 239.921 15.2519 239.258 16.127 238.621C18.8139 236.674 21.4995 234.724 24.1839 232.771L23.3433 237.64C22.8251 240.638 22.2838 243.697 21.0018 246.438C20.8598 246.748 20.7063 247.055 20.5411 247.354H8.05103C7.95056 247.076 7.88106 246.788 7.84376 246.495C7.84064 246.476 7.83938 246.457 7.84 246.438C7.64414 244.578 8.6729 242.827 9.66323 241.236Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M199.432 240.469L196.473 235.719L195.881 238.433C195.778 238.909 195.674 239.392 195.578 239.871C194.738 239.154 193.843 238.491 192.968 237.855C190.281 235.907 187.596 233.957 184.911 232.005L185.752 236.873C186.27 239.871 186.811 242.93 188.093 245.671C188.235 245.982 188.389 246.288 188.554 246.587H201.044C201.145 246.309 201.214 246.021 201.251 245.728C201.255 245.709 201.256 245.69 201.255 245.671C201.451 243.812 200.422 242.06 199.432 240.469Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M216.705 240.469L213.745 235.719L213.154 238.433C213.051 238.909 212.947 239.392 212.851 239.871C212.01 239.154 211.116 238.491 210.241 237.855C207.554 235.907 204.868 233.957 202.184 232.005L203.025 236.873C203.543 239.871 204.084 242.93 205.366 245.671C205.508 245.982 205.662 246.288 205.827 246.587H218.317C218.417 246.309 218.487 246.021 218.524 245.728C218.527 245.709 218.529 245.69 218.528 245.671C218.724 243.812 217.695 242.06 216.705 240.469Z'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M217.012 101.108H195.517C195.263 101.108 195.019 101.209 194.839 101.389C194.659 101.568 194.558 101.812 194.558 102.066C194.558 102.32 194.659 102.564 194.839 102.744C195.019 102.924 195.263 103.025 195.517 103.025H217.012C217.267 103.025 217.511 102.924 217.691 102.744C217.871 102.564 217.972 102.32 217.972 102.066C217.972 101.812 217.871 101.568 217.691 101.389C217.511 101.209 217.267 101.108 217.012 101.108Z'),
							$elm$svg$Svg$Attributes$fill('white')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M191.679 122.384C192.527 122.384 193.214 121.697 193.214 120.85C193.214 120.003 192.527 119.317 191.679 119.317C190.831 119.317 190.144 120.003 190.144 120.85C190.144 121.697 190.831 122.384 191.679 122.384Z'),
							$elm$svg$Svg$Attributes$fill('white')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M159.844 75.0063L146.719 73.8716L142.186 80.1604L136.812 135.745L162.774 137.789L174.407 141.004L159.844 75.0063Z'),
							$elm$svg$Svg$Attributes$fill('#303436')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M135.325 242.267L140.303 242.267L142.671 223.09L135.324 223.09L135.325 242.267Z'),
							$elm$svg$Svg$Attributes$fill('#FFB6B6')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M134.055 240.644L135.456 240.644L140.927 238.422L143.859 240.644C145.516 240.644 147.105 241.301 148.277 242.471C149.449 243.641 150.107 245.228 150.107 246.883V247.086L134.055 247.087L134.055 240.644Z'),
							$elm$svg$Svg$Attributes$fill('#303436')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M154.616 239.134L159.472 240.229L166.012 222.044L158.845 220.429L154.616 239.134Z'),
							$elm$svg$Svg$Attributes$fill('#FFB6B6')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M153.736 237.272L155.103 237.58L160.929 236.616L163.299 239.428C164.915 239.793 166.321 240.783 167.205 242.183C168.09 243.582 168.382 245.275 168.017 246.889L167.973 247.087L152.315 243.556L153.736 237.272Z'),
							$elm$svg$Svg$Attributes$fill('#303436')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M129.02 125.03C126.686 132.06 126.933 139.692 129.581 147.882L130.713 193.996C128.842 196.053 128.555 214.459 131.438 220.465C135.288 228.485 131.748 229.557 134.469 234.878H142.363L146.011 210.773L146.271 191.234C147.319 188.755 146.458 180.031 146.458 180.031L146.761 161.94L160.994 193.631C154.546 199.143 155.126 216.948 155.02 224.845L152.906 234.164L162.621 235.031L166.908 222.394L171.728 214.606C174.184 200.807 174.913 190.677 172.818 186.539L158.531 133.451L129.02 125.03Z'),
							$elm$svg$Svg$Attributes$fill('#303436')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M127.437 125.406C127.464 125.97 127.581 126.526 127.782 127.054C127.805 127.119 127.828 127.18 127.855 127.246C128.329 128.376 129.17 129.315 130.243 129.91C130.558 130.088 130.892 130.233 131.237 130.343L134.227 130.822L159.94 134.928L160.973 131.827L159.027 126.966L160.316 122.787L160.608 82.2984V82.2677L155.937 74.827L155.898 70.1234L142.856 69.8052L141.439 73.3933L138.641 75.0647C132.438 78.7678 130.204 85.5492 130.339 92.7676C132.477 101.036 130.903 110.229 129.31 120.085L128.009 122.684C127.587 123.527 127.39 124.464 127.437 125.406Z'),
							$elm$svg$Svg$Attributes$class('fill-accent')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$opacity('0.2'),
							$elm$svg$Svg$Attributes$d('M127.437 125.406C127.464 125.97 127.581 126.526 127.782 127.054L130.243 129.91C130.558 130.088 130.892 130.233 131.237 130.343L134.227 130.822L129.901 122.699L139.409 101.91L127.437 125.406Z'),
							$elm$svg$Svg$Attributes$fill('black')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M154.563 74.5281L141.439 73.3933C137.691 75.1047 134.453 77.7615 132.044 81.1022C129.636 84.4429 128.14 88.3523 127.704 92.4457L123.378 133.062L151.259 137.79L162.892 141.004L154.563 74.5281Z'),
							$elm$svg$Svg$Attributes$fill('#303436')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M138.615 56.6374C139.052 59.823 140.738 62.705 143.302 64.65C145.866 66.595 149.098 67.444 152.288 67.0104C155.478 66.5768 158.365 64.896 160.315 62.3374C162.265 59.7789 163.119 56.5518 162.688 53.3653L162.664 53.1931C162.161 50.0495 160.44 47.2294 157.874 45.3412C155.307 43.453 152.1 42.648 148.945 43.0999C145.79 43.5519 142.938 45.2244 141.007 47.7569C139.075 50.2893 138.217 53.4786 138.619 56.6369L138.615 56.6374Z'),
							$elm$svg$Svg$Attributes$fill('#FFB8B8')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M141.707 62.886C141.083 61.6205 140.442 60.2618 140.618 58.8622C140.793 57.4625 142.167 56.1247 143.517 56.5407C144.324 56.7894 144.934 57.5853 145.777 57.626C146.938 57.6821 147.604 56.3554 147.965 55.2523L149.436 50.7598C150.849 51.8596 152.488 52.6343 154.235 53.0287C155.983 53.423 157.795 53.4273 159.545 53.0411C160.911 52.7292 162.291 52.121 163.092 50.9728C163.894 49.8246 163.889 48.0435 162.79 47.1753C162.251 46.7496 161.533 46.5878 161.018 46.1335C160.699 45.8517 160.479 45.4747 160.39 45.0582C160.302 44.6417 160.351 44.2079 160.528 43.8209C160.706 43.434 161.004 43.1145 161.378 42.9097C161.751 42.705 162.181 42.6258 162.603 42.6839L158.899 42.2215L160.002 40.2276C159.207 40.8538 158.1 40.938 157.103 40.7587C156.106 40.5795 155.168 40.1696 154.193 39.8963C149.511 38.584 144.071 40.8657 141.731 45.1223C140.819 44.8183 139.837 44.7981 138.913 45.0644C137.99 45.3307 137.169 45.8709 136.56 46.6135C135.568 47.8707 135.298 49.5484 135.26 51.1484C135.188 54.3033 135.877 57.4292 137.268 60.2624C137.667 61.1623 138.241 61.9745 138.955 62.6523C139.315 62.9884 139.744 63.2418 140.212 63.3947C140.68 63.5476 141.176 63.5964 141.666 63.5375'),
							$elm$svg$Svg$Attributes$fill('#303436')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M151.758 136.873L126.852 132.244L134.858 89.2802C135.163 87.647 135.786 86.0896 136.693 84.697C137.6 83.3044 138.773 82.1039 140.144 81.1639C141.516 80.224 143.059 79.5631 144.687 79.2189C146.314 78.8747 147.993 78.854 149.629 79.1579C151.264 79.4619 152.823 80.0846 154.218 80.9904C155.612 81.8962 156.814 83.0675 157.755 84.4372C158.697 85.807 159.358 87.3486 159.703 88.9738C160.048 90.599 160.068 92.2761 159.764 93.9093L151.758 136.873ZM128.642 131.017L150.529 135.085L158.255 93.6288C158.523 92.1932 158.505 90.7189 158.203 89.2901C157.9 87.8613 157.319 86.506 156.492 85.3016C155.665 84.0972 154.609 83.0674 153.383 82.271C152.157 81.4745 150.786 80.927 149.349 80.6598C147.911 80.3926 146.435 80.4109 145.005 80.7137C143.574 81.0164 142.217 81.5977 141.012 82.4242C139.806 83.2508 138.776 84.3065 137.979 85.531C137.182 86.7554 136.635 88.1247 136.368 89.5606L128.642 131.017Z'),
							$elm$svg$Svg$Attributes$fill('#B1B6B9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M120.888 150.319L148.863 156.386C150.46 156.732 152.036 155.72 152.383 154.125L156.474 135.31C156.82 133.715 155.807 132.141 154.21 131.795L126.234 125.728C124.637 125.382 123.062 126.394 122.715 127.989L118.624 146.804C118.277 148.399 119.291 149.972 120.888 150.319Z'),
							$elm$svg$Svg$Attributes$fill('#B1B6B9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M137.093 132.347V138.143L137.389 138.208L137.75 138.288L147.706 140.493H147.714L150.762 141.167H150.892C150.998 141.168 151.102 141.147 151.199 141.105C151.297 141.063 151.384 141.003 151.457 140.926C151.588 140.784 151.661 140.598 151.66 140.405V132.347C151.661 132.229 151.633 132.112 151.58 132.007C151.527 131.901 151.449 131.81 151.353 131.741C151.338 131.725 151.321 131.711 151.303 131.699C151.246 131.666 151.185 131.639 151.123 131.618C151.117 131.615 151.11 131.614 151.103 131.614C151.102 131.613 151.1 131.612 151.098 131.611C151.096 131.611 151.094 131.61 151.092 131.611C151.027 131.594 150.96 131.585 150.892 131.584H137.846C137.688 131.583 137.534 131.634 137.408 131.729C137.31 131.8 137.231 131.893 137.176 132C137.121 132.107 137.093 132.226 137.093 132.347Z'),
							$elm$svg$Svg$Attributes$fill('white')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M137.093 132.347V138.143L137.389 138.208L137.75 138.288C137.714 138.177 137.686 138.063 137.665 137.947C137.658 137.923 137.653 137.899 137.65 137.874C137.622 137.709 137.608 137.541 137.608 137.372V132.347C137.608 132.28 137.635 132.217 137.683 132.17C137.73 132.123 137.794 132.097 137.861 132.097H150.892C150.959 132.097 151.023 132.123 151.07 132.17C151.118 132.217 151.145 132.28 151.146 132.347V139.753C151.144 139.939 151.07 140.117 150.938 140.25C150.807 140.382 150.63 140.458 150.443 140.462C150.178 140.466 149.829 140.47 149.415 140.474C148.931 140.481 148.355 140.489 147.714 140.493L150.762 141.167H150.892C150.998 141.168 151.102 141.147 151.199 141.105C151.297 141.063 151.384 141.003 151.457 140.926C151.588 140.784 151.661 140.598 151.66 140.405V132.347C151.661 132.229 151.633 132.112 151.58 132.007C151.527 131.901 151.449 131.81 151.353 131.741C151.338 131.725 151.321 131.711 151.303 131.699C151.246 131.666 151.185 131.639 151.123 131.618C151.117 131.615 151.11 131.614 151.103 131.614C151.102 131.613 151.1 131.612 151.098 131.611C151.096 131.611 151.094 131.61 151.092 131.611C151.027 131.594 150.96 131.585 150.892 131.584H137.846C137.688 131.583 137.534 131.634 137.408 131.729C137.31 131.8 137.231 131.893 137.176 132C137.121 132.107 137.093 132.226 137.093 132.347ZM137.093 137.587V137.748L137.65 137.874C137.622 137.709 137.608 137.541 137.608 137.372V137.096C137.439 137.265 137.266 137.426 137.093 137.587Z'),
							$elm$svg$Svg$Attributes$fill('#6B7276')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M139.579 136.727H149.509C149.597 136.727 149.682 136.7 149.754 136.65C149.826 136.599 149.88 136.528 149.91 136.446L151.444 132.173C151.462 132.121 151.47 132.065 151.468 132.01C151.465 131.954 151.451 131.899 151.427 131.849C151.403 131.799 151.369 131.754 151.328 131.717C151.286 131.68 151.238 131.651 151.185 131.633C151.14 131.616 151.091 131.608 151.043 131.608L137.726 131.585H137.725C137.655 131.584 137.586 131.601 137.524 131.634C137.462 131.667 137.409 131.715 137.37 131.774C137.331 131.832 137.308 131.899 137.301 131.969C137.295 132.039 137.306 132.11 137.334 132.174L139.188 136.471C139.221 136.547 139.276 136.612 139.345 136.657C139.415 136.703 139.496 136.727 139.579 136.727Z'),
							$elm$svg$Svg$Attributes$fill('#6B7276')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M144.384 137.781C144.97 137.781 145.445 137.309 145.445 136.727C145.445 136.145 144.97 135.673 144.384 135.673C143.798 135.673 143.323 136.145 143.323 136.727C143.323 137.309 143.798 137.781 144.384 137.781Z'),
							$elm$svg$Svg$Attributes$fill('#303436')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M126.53 135.808L126.776 135.862L127.252 135.965L132.146 137.05L136.621 138.039L137.093 138.143L137.389 138.208L137.665 137.947L137.727 137.89L139.201 136.494L142.812 133.079C142.944 132.955 143.027 132.788 143.047 132.608C143.067 132.428 143.022 132.247 142.92 132.097C142.899 132.061 142.873 132.027 142.843 131.998L142.459 131.591L142.452 131.584L137.297 126.148C137.214 126.06 137.111 125.993 136.997 125.953C136.882 125.913 136.76 125.901 136.64 125.918C136.627 125.918 136.615 125.919 136.602 125.922C136.52 125.938 136.44 125.968 136.368 126.01C136.312 126.04 136.26 126.077 136.214 126.121L126.749 135.072L126.741 135.08C126.646 135.171 126.577 135.286 126.542 135.413C126.53 135.444 126.526 135.471 126.519 135.494C126.503 135.598 126.507 135.705 126.53 135.808Z'),
							$elm$svg$Svg$Attributes$fill('white')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M126.53 135.808L126.776 135.862L127.252 135.965L127.09 135.797C127.057 135.761 127.035 135.717 127.027 135.669C127.019 135.622 127.025 135.573 127.044 135.528C127.057 135.496 127.077 135.468 127.102 135.444L136.567 126.493C136.591 126.47 136.619 126.452 136.65 126.44C136.681 126.428 136.713 126.423 136.746 126.424C136.779 126.425 136.812 126.433 136.842 126.447C136.872 126.46 136.898 126.48 136.921 126.504L137.381 126.987L141.738 131.584L141.745 131.591L142.022 131.883C142.081 131.945 142.128 132.018 142.16 132.097C142.213 132.229 142.226 132.372 142.198 132.511C142.169 132.65 142.1 132.776 141.999 132.876C141.419 133.439 140.283 134.539 138.917 135.843C138.498 136.249 138.062 136.667 137.608 137.096C137.439 137.265 137.266 137.426 137.093 137.587C137.047 137.633 137.001 137.679 136.955 137.717C136.844 137.828 136.732 137.932 136.621 138.039L137.093 138.143L137.389 138.208L137.665 137.947L137.727 137.89L139.201 136.494L142.812 133.079C142.944 132.955 143.027 132.788 143.047 132.608C143.067 132.428 143.022 132.247 142.92 132.097C142.899 132.061 142.873 132.027 142.843 131.998L142.459 131.591L142.452 131.584L137.297 126.148C137.214 126.06 137.111 125.993 136.997 125.953C136.882 125.913 136.76 125.901 136.64 125.918C136.627 125.918 136.615 125.919 136.602 125.922C136.52 125.938 136.44 125.968 136.368 126.01C136.312 126.04 136.26 126.077 136.214 126.121L126.749 135.072L126.741 135.08C126.646 135.171 126.577 135.286 126.542 135.413C126.53 135.444 126.526 135.471 126.519 135.494C126.503 135.598 126.507 135.705 126.53 135.808Z'),
							$elm$svg$Svg$Attributes$fill('#6B7276')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M126.519 135.475V135.494C126.523 135.594 126.564 135.69 126.634 135.762C126.674 135.804 126.722 135.838 126.776 135.862L127.252 135.965L132.146 137.05L132.487 136.728L134.257 135.053L135.8 133.596L137.093 132.37L137.327 132.151L137.926 131.584L138.748 130.806C138.812 130.746 138.856 130.668 138.874 130.582C138.892 130.496 138.882 130.407 138.847 130.326L137.381 126.987L137.02 126.171C136.988 126.097 136.935 126.034 136.868 125.989C136.8 125.944 136.721 125.919 136.64 125.918C136.627 125.918 136.615 125.919 136.602 125.922C136.553 125.922 136.504 125.934 136.46 125.956C136.427 125.97 136.396 125.988 136.368 126.01C136.356 126.018 136.349 126.029 136.337 126.037L126.749 135.072L126.741 135.08L126.653 135.164C126.59 135.234 126.546 135.318 126.526 135.41C126.52 135.431 126.517 135.453 126.519 135.475Z'),
							$elm$svg$Svg$Attributes$fill('#6B7276')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M135.753 135.091C136.179 134.688 136.199 134.019 135.798 133.597C135.398 133.174 134.728 133.158 134.302 133.56C133.877 133.963 133.857 134.631 134.257 135.054C134.658 135.477 135.328 135.493 135.753 135.091Z'),
							$elm$svg$Svg$Attributes$fill('#303436')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M125.459 135.571L126.53 135.808L126.776 135.862L127.252 135.965L132.146 137.05L136.621 138.039L137.093 138.143L137.389 138.208L137.75 138.288L147.706 140.493H147.714L150.762 141.167L152.201 141.486L155.602 134.574L155.257 134.405L151.99 141.045L151.457 140.926L149.415 140.474L137.727 137.89L137.65 137.874L137.093 137.748L136.955 137.717L132.487 136.728L127.044 135.528L126.542 135.413L126.526 135.41L125.858 135.264L126.234 127.758L125.851 127.743L125.459 135.571Z'),
							$elm$svg$Svg$Attributes$fill('#B1B6B9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M259.5 247.544C259.5 247.604 259.488 247.663 259.466 247.719C259.443 247.774 259.409 247.824 259.367 247.867C259.324 247.909 259.274 247.943 259.218 247.966C259.163 247.989 259.103 248 259.043 248H0.992048C0.870905 248 0.754723 247.952 0.669062 247.866C0.583401 247.781 0.535278 247.665 0.535278 247.544C0.535278 247.423 0.583401 247.307 0.669062 247.221C0.754723 247.136 0.870905 247.088 0.992048 247.088H259.043C259.103 247.087 259.163 247.099 259.218 247.122C259.274 247.145 259.324 247.178 259.367 247.221C259.409 247.263 259.443 247.314 259.466 247.369C259.488 247.424 259.5 247.484 259.5 247.544Z'),
							$elm$svg$Svg$Attributes$fill('#B1B6B9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M153.398 145.52C152.915 145.221 152.503 144.819 152.192 144.344C151.881 143.869 151.678 143.331 151.597 142.769C151.517 142.207 151.561 141.634 151.726 141.091C151.891 140.547 152.174 140.047 152.553 139.624L141.193 125.309L139.491 106.434L147.921 107.11L148.122 121.735L158.279 139.488C158.948 140.172 159.341 141.077 159.386 142.032C159.431 142.987 159.123 143.926 158.521 144.669C157.92 145.413 157.066 145.91 156.121 146.067C155.177 146.224 154.208 146.029 153.398 145.52Z'),
							$elm$svg$Svg$Attributes$fill('#FFB6B6')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M139.094 93.9125C139.272 97.3884 138.932 116.729 140.449 121.317C139.871 121.671 139.427 122.206 139.186 122.84C138.946 123.473 138.924 124.168 139.123 124.816L148.965 122.752C150.117 120.789 148.872 119.915 148.04 119.585L149.293 113.039L151.968 89.5808C152.084 88.564 151.926 87.5347 151.511 86.5991C151.096 85.6635 150.438 84.8554 149.606 84.2582C148.895 83.7495 148.078 83.4089 147.216 83.2623C146.353 83.1156 145.469 83.1667 144.63 83.4117C143.79 83.6567 143.017 84.0891 142.37 84.6763C141.722 85.2635 141.217 85.99 140.892 86.801C139.864 89.342 139 92.0748 139.094 93.9125Z'),
							$elm$svg$Svg$Attributes$class('fill-accent')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('clip0_1657_2013')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$rect,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$width('259'),
									$elm$svg$Svg$Attributes$height('248'),
									$elm$svg$Svg$Attributes$fill('white'),
									$elm$svg$Svg$Attributes$transform('translate(0.5)')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Page$Agents$AccountAccess$viewEmailMissing = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col items-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('There\'s a chance that the email went to your spam folder. Otherwise, request a new verification email.')
					])),
				$author$project$Pwr$Ui$ButtonWithSpinner$view(
				{
					aM: _List_fromArray(
						[
							_Utils_Tuple2('btn btn-primary px-12 py-2 rounded-lg mt-5', true)
						]),
					aP: false,
					aU: model.Y,
					aD: 'Resend email',
					ba: $author$project$Pwr$Ui$ButtonWithSpinner$Button($author$project$Page$Agents$AccountAccess$ClickedResendEmail),
					bd: 'w-[190px]'
				}),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('my-7 px-7')
					]),
				_List_fromArray(
					[$author$project$Pwr$Ui$Agent$Graphic$viewMissingMail])),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(
						$elm$core$String$concat(
							_List_fromArray(
								[
									'mailto:',
									$author$project$Constants$supportEmailAddress(model.o)
								]))),
						$elm$html$Html$Attributes$class('link')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Contact support')
					]))
			]));
};
var $author$project$Page$Agents$AccountAccess$ClickedHaventReceivedEmail = {$: 1};
var $author$project$Pwr$Ui$Agent$Graphic$viewEmailSent = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('244'),
			$elm$svg$Svg$Attributes$height('200'),
			$elm$svg$Svg$Attributes$viewBox('0 0 244 200'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$clipPath('url(#clip0_999_1047)')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M178.362 164.65C180.292 165.33 182.363 165.501 184.377 165.145C186.391 164.789 188.28 163.92 189.861 162.62C193.889 159.231 195.151 153.647 196.179 148.477L199.218 133.186L192.855 137.578C188.28 140.736 183.601 143.996 180.433 148.571C177.265 153.146 175.882 159.391 178.428 164.342'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M178.906 183.164C178.262 178.462 177.6 173.699 178.052 168.946C178.453 164.724 179.737 160.601 182.352 157.221C183.741 155.43 185.43 153.895 187.344 152.686C187.843 152.37 188.302 153.163 187.805 153.478C184.493 155.576 181.932 158.675 180.49 162.327C178.897 166.389 178.641 170.816 178.916 175.131C179.082 177.74 179.433 180.332 179.788 182.921C179.816 183.038 179.798 183.161 179.739 183.266C179.68 183.37 179.583 183.449 179.468 183.485C179.352 183.516 179.227 183.5 179.122 183.44C179.016 183.38 178.939 183.281 178.906 183.164Z'),
							$elm$svg$Svg$Attributes$fill('#EFF0F0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M185.109 174.843C185.936 176.104 187.074 177.13 188.411 177.822C189.749 178.514 191.242 178.849 192.746 178.795C196.613 178.611 199.836 175.906 202.738 173.337L211.32 165.74L205.64 165.468C201.555 165.272 197.365 165.089 193.474 166.352C189.584 167.615 185.996 170.654 185.284 174.691'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M177.086 185.868C180.186 180.369 183.781 174.258 190.205 172.305C191.991 171.764 193.864 171.57 195.723 171.734C196.308 171.785 196.162 172.69 195.577 172.64C192.462 172.38 189.352 173.205 186.772 174.975C184.289 176.67 182.356 179.025 180.719 181.523C179.717 183.053 178.819 184.648 177.921 186.241C177.635 186.75 176.796 186.383 177.086 185.868Z'),
							$elm$svg$Svg$Attributes$fill('#EFF0F0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M100.693 147.24C96.8912 148.58 92.8087 148.916 88.8394 148.215C84.8701 147.514 81.1478 145.8 78.0311 143.238C70.0934 136.558 67.6047 125.554 65.5798 115.365C63.5833 105.319 61.5868 95.273 59.5903 85.2271L72.1298 93.8834C81.1475 100.108 90.3683 106.533 96.612 115.55C102.856 124.567 105.581 136.875 100.565 146.632'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M99.6215 183.728C100.891 174.46 102.196 165.073 101.305 155.705C100.515 147.386 97.9831 139.26 92.829 132.597C90.0932 129.068 86.7642 126.043 82.9918 123.66C82.008 123.038 81.1026 124.601 82.0821 125.221C88.6095 129.357 93.6583 135.464 96.5004 142.662C99.6394 150.667 100.144 159.392 99.6026 167.895C99.2754 173.038 98.5822 178.146 97.8835 183.248C97.8284 183.479 97.8628 183.722 97.9796 183.928C98.0965 184.135 98.2871 184.289 98.5129 184.36C98.7434 184.422 98.989 184.39 99.1965 184.272C99.404 184.154 99.5567 183.959 99.6215 183.728Z'),
							$elm$svg$Svg$Attributes$fill('#EFF0F0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M87.397 167.328C85.7663 169.813 83.5247 171.835 80.8883 173.199C78.2518 174.563 75.3094 175.224 72.3444 175.117C64.7245 174.754 58.372 169.422 52.6535 164.36L35.7393 149.388L46.9337 148.851C54.984 148.465 63.242 148.104 70.9097 150.593C78.5774 153.082 85.6489 159.072 87.051 167.029'),
							$elm$svg$Svg$Attributes$fill('#E7E8E9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M103.208 189.056C97.0996 178.22 90.0141 166.176 77.3534 162.327C73.8331 161.26 70.1419 160.878 66.4785 161.201C65.3239 161.301 65.6122 163.085 66.7647 162.986C72.9054 162.474 79.0342 164.1 84.1194 167.589C89.0128 170.928 92.8228 175.571 96.0476 180.494C98.0229 183.509 99.7922 186.653 101.562 189.792C102.127 190.796 103.78 190.071 103.208 189.056Z'),
							$elm$svg$Svg$Attributes$fill('#EFF0F0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M56.0599 42.3463L3.46414 31.2988L2.78064 31.1556C2.43254 31.0819 2.07079 31.1083 1.73697 31.2316C1.40316 31.3549 1.11084 31.5702 0.893631 31.8527C0.676425 32.1351 0.543157 32.4733 0.509146 32.8284C0.475135 33.1834 0.541767 33.5409 0.701377 33.8596L21.8088 76.1974C21.9454 76.4694 22.1452 76.7045 22.3914 76.883C22.6375 77.0614 22.9228 77.178 23.2232 77.2228C23.5246 77.268 23.8325 77.2389 24.1201 77.1381C24.4078 77.0373 24.6667 76.8678 24.8744 76.6442L39.2697 61.2445C39.3721 61.1322 39.4966 61.0424 39.6353 60.9807C39.774 60.919 39.9239 60.8867 40.0757 60.8859C40.2819 60.8818 40.4854 60.9339 40.6644 61.0368C40.8433 61.1397 40.991 61.2895 41.0916 61.47L44.0913 66.9546C44.2829 67.3204 44.591 67.6114 44.9667 67.7812C45.3423 67.9511 45.7638 67.9901 46.1641 67.892L46.1788 67.8887C46.584 67.8001 46.9477 67.5775 47.2115 67.2566C47.4753 66.9358 47.6238 66.5353 47.6332 66.1196L48.1523 53.4149C48.1585 53.2564 48.1971 53.1008 48.2656 52.9578C48.3393 52.8163 48.4397 52.6905 48.5613 52.5874L56.8777 45.6599C57.151 45.4322 57.3549 45.1319 57.4658 44.7934C57.5768 44.4549 57.5904 44.0919 57.505 43.7461C57.4196 43.4002 57.2388 43.0854 56.9832 42.8379C56.7276 42.5903 56.4076 42.4199 56.0599 42.3463ZM56.397 45.0781L48.0806 52.0056C47.9722 52.0941 47.8741 52.1947 47.7882 52.3053L3.37589 32.4299C3.33672 32.4119 3.29587 32.3978 3.25395 32.3878C3.08285 32.3447 2.90209 32.3629 2.74294 32.4392C2.5838 32.5156 2.45627 32.6453 2.38241 32.8059C2.30854 32.9665 2.29299 33.148 2.33844 33.3189C2.38389 33.4898 2.48749 33.6394 2.63132 33.7418L39.2089 60.3455C39.0247 60.443 38.8586 60.5715 38.7179 60.7256L24.3228 76.1251C24.1978 76.2585 24.0427 76.3596 23.8704 76.42C23.6982 76.4803 23.5139 76.4981 23.3333 76.4718C23.1528 76.4455 22.9812 76.3759 22.8332 76.2688C22.6852 76.1618 22.5652 76.0206 22.4833 75.8571L1.37587 33.5193C1.2815 33.328 1.24262 33.114 1.26366 32.9016C1.2847 32.6893 1.36482 32.4871 1.49488 32.3181C1.62495 32.1492 1.79972 32.0203 1.99931 31.946C2.19889 31.8718 2.41526 31.8553 2.62376 31.8983L3.32349 32.0456L55.9029 43.0891C56.1116 43.1332 56.3038 43.2352 56.4574 43.3836C56.611 43.5321 56.7198 43.7209 56.7714 43.9284C56.8229 44.136 56.8152 44.3539 56.7489 44.5572C56.6827 44.7605 56.5608 44.941 56.397 45.0781Z'),
							$elm$svg$Svg$Attributes$fill('#D4D7D8')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M56.0599 42.3463L3.46414 31.2988L2.78064 31.1556C2.43254 31.0819 2.07079 31.1083 1.73697 31.2316C1.40316 31.3549 1.11084 31.5702 0.893631 31.8527C0.676425 32.1351 0.543157 32.4733 0.509146 32.8284C0.475135 33.1834 0.541767 33.5409 0.701377 33.8596L21.8088 76.1974C21.9454 76.4694 22.1452 76.7045 22.3914 76.883C22.6375 77.0614 22.9228 77.178 23.2232 77.2228C23.5246 77.268 23.8325 77.2389 24.1201 77.1381C24.4078 77.0373 24.6667 76.8678 24.8744 76.6442L39.2697 61.2445C39.3721 61.1322 39.4966 61.0424 39.6353 60.9807C39.774 60.919 39.9239 60.8867 40.0757 60.8859C40.2819 60.8818 40.4854 60.9339 40.6644 61.0368C40.8433 61.1397 40.991 61.2895 41.0916 61.47L44.0913 66.9546C44.2829 67.3204 44.591 67.6114 44.9667 67.7812C45.3423 67.9511 45.7638 67.9901 46.1641 67.892L46.1788 67.8887C46.584 67.8001 46.9477 67.5775 47.2115 67.2566C47.4753 66.9358 47.6238 66.5353 47.6332 66.1196L48.1523 53.4149C48.1585 53.2564 48.1971 53.1008 48.2656 52.9578C48.3393 52.8163 48.4397 52.6905 48.5613 52.5874L56.8777 45.6599C57.151 45.4322 57.3549 45.1319 57.4658 44.7934C57.5768 44.4549 57.5904 44.0919 57.505 43.7461C57.4196 43.4002 57.2388 43.0854 56.9832 42.8379C56.7276 42.5903 56.4076 42.4199 56.0599 42.3463ZM56.397 45.0781L48.0806 52.0056C47.9722 52.0942 47.8741 52.1947 47.7882 52.3053C47.7107 52.4037 47.6439 52.5101 47.5889 52.6227C47.5313 52.7379 47.4861 52.8589 47.454 52.9837L47.4548 52.9873C47.421 53.1173 47.4018 53.2507 47.3977 53.385L46.8787 66.0897C46.8752 66.3394 46.787 66.5806 46.6287 66.7734C46.4703 66.9663 46.2512 67.0994 46.0074 67.1508L46 67.1525C45.7598 67.2138 45.506 67.192 45.2797 67.0906C45.0535 66.9892 44.868 66.8141 44.7534 66.5938L41.7528 61.1055C41.5982 60.8232 41.3742 60.5852 41.1021 60.4141C40.83 60.243 40.5188 60.1444 40.198 60.1277L40.1944 60.1285C40.1513 60.1267 40.1083 60.1249 40.0661 60.1267C39.7669 60.1286 39.4727 60.2037 39.209 60.3455C39.0247 60.443 38.8586 60.5715 38.718 60.7255L24.3228 76.1251C24.1978 76.2585 24.0427 76.3596 23.8704 76.42C23.6982 76.4803 23.5139 76.4981 23.3333 76.4718C23.1528 76.4455 22.9812 76.3759 22.8332 76.2688C22.6852 76.1618 22.5652 76.0206 22.4833 75.8571L1.37587 33.5193C1.2815 33.328 1.24262 33.114 1.26366 32.9016C1.2847 32.6893 1.36482 32.4871 1.49488 32.3181C1.62495 32.1492 1.79972 32.0203 1.99931 31.946C2.19889 31.8718 2.41526 31.8553 2.62376 31.8983L3.32349 32.0456L55.9029 43.0891C56.1116 43.1332 56.3038 43.2352 56.4574 43.3836C56.611 43.5321 56.7198 43.7209 56.7714 43.9284C56.8229 44.136 56.8152 44.3539 56.7489 44.5572C56.6827 44.7605 56.5608 44.941 56.397 45.0781Z'),
							$elm$svg$Svg$Attributes$fill('#949A9E')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M47.9563 52.3795L47.6483 53.0713L47.4549 52.9872L47.4541 52.9835L3.077 33.1273L40.1945 60.1283L40.1981 60.1275L40.2964 60.2022L39.8545 60.8158L39.2091 60.3454L2.63142 33.7417C2.48759 33.6392 2.38399 33.4896 2.33853 33.3187C2.29308 33.1478 2.30862 32.9663 2.38249 32.8057C2.45635 32.6451 2.58389 32.5154 2.74305 32.439C2.9022 32.3627 3.08297 32.3445 3.25408 32.3876C3.296 32.3976 3.33684 32.4117 3.37602 32.4297L47.7883 52.3051L47.9563 52.3795Z'),
							$elm$svg$Svg$Attributes$fill('#949A9E')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M162.146 105.311L164.066 124.125L164.104 124.511L164.674 130.091L169.359 176.03V176.038L170.27 184.951C169.914 185.43 169.599 185.938 169.329 186.47C168.504 188.103 168.1 189.917 168.156 191.747C168.211 193.577 168.724 195.363 169.646 196.943C171.932 196.367 174.186 195.711 176.409 194.973C181.008 193.457 185.492 191.614 189.829 189.458C189.378 186.97 188.082 184.715 186.161 183.076L181.457 126.413L181.045 121.443L179.704 105.311H162.146Z'),
							$elm$svg$Svg$Attributes$fill('#DFA290')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M175.599 54.0671C185.3 44.3413 185.3 28.5727 175.599 18.847C165.899 9.12125 150.17 9.12126 140.469 18.847C130.768 28.5728 130.768 44.3413 140.469 54.0671C150.17 63.7928 165.899 63.7928 175.599 54.0671Z'),
							$elm$svg$Svg$Attributes$fill('#DFA290')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M111.734 139.246C111.738 139.295 111.742 139.345 111.746 139.39C111.828 140.362 112.219 141.281 112.86 142.015C113.501 142.748 114.359 143.256 115.309 143.466L152.38 151.583C152.702 151.654 153.03 151.689 153.359 151.689C154.353 151.689 155.32 151.362 156.111 150.757C156.902 150.153 157.473 149.306 157.738 148.345C157.817 148.049 157.904 147.746 157.998 147.432V147.428C159.249 143.17 161.482 137.375 164.675 130.091C165.396 128.443 166.168 126.717 166.991 124.913C167.142 124.58 167.297 124.242 167.448 123.905C169.144 120.212 171.037 116.215 173.126 111.913C174.149 109.81 174.921 107.594 175.427 105.311C176.773 99.2822 176.242 92.9849 173.905 87.2689C173.429 86.1052 172.88 84.9729 172.261 83.8788C169.821 79.5662 166.364 75.9193 162.192 73.2573C158.02 70.5954 153.26 68.9996 148.33 68.6098C147.548 68.5454 146.77 68.5151 145.988 68.5151C138.165 68.5497 130.656 71.6047 125.022 77.0454C121.698 80.2773 119.173 84.2441 117.651 88.6288C117.553 88.9053 117.462 89.1856 117.372 89.4659C115.976 93.9023 114.855 98.421 114.016 102.996C113.514 105.712 113.106 108.39 112.777 111C111.625 120.368 111.276 129.818 111.734 139.246Z'),
							$elm$svg$Svg$Attributes$class('fill-accent')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M95.4082 186.837C117.931 199.671 144.526 203.292 169.646 196.943C171.932 196.367 174.186 195.711 176.409 194.973C174.437 188.526 172.083 182.203 169.359 176.038V176.03C164.818 165.822 160.647 159.576 158.614 156.818C158.28 156.361 158.06 155.831 157.972 155.271C157.885 154.712 157.933 154.139 158.111 153.602L158.742 151.704C158.983 150.986 159.04 150.22 158.91 149.473C158.78 148.727 158.467 148.026 157.998 147.432V147.428C157.957 147.375 157.911 147.322 157.866 147.269C141.351 128.405 112.561 138.697 112.27 138.803L112.127 138.856L112.036 138.981C111.938 139.117 111.84 139.25 111.745 139.39C103.939 150.356 98.752 167.212 95.4082 186.837Z'),
							$elm$svg$Svg$Attributes$fill('#4B5053')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M61.4631 65.3861C61.5872 65.9333 61.6681 66.4893 61.7051 67.0492L105.152 92.1776L115.712 86.0826L126.97 100.859L109.321 113.47C107.895 114.489 106.178 115.016 104.428 114.974C102.677 114.931 100.988 114.32 99.6134 113.233L54.8124 77.7986C52.7906 78.5489 50.5888 78.6643 48.4999 78.1295C46.411 77.5947 44.534 76.4349 43.1186 74.8045C41.7032 73.1741 40.8165 71.1503 40.5763 69.0023C40.3362 66.8543 40.754 64.6839 41.7742 62.7798C42.7945 60.8757 44.3687 59.3281 46.2877 58.3429C48.2066 57.3577 50.3793 56.9815 52.5167 57.2644C54.654 57.5474 56.6548 58.476 58.253 59.9268C59.8511 61.3776 60.9707 63.2818 61.4631 65.3861Z'),
							$elm$svg$Svg$Attributes$fill('#DFA290')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M105.818 91.7917V91.7955C105.975 92.3658 106.242 92.8997 106.603 93.3674L114.016 102.996L117.549 107.591L120.647 111.614C121.046 112.133 121.553 112.559 122.131 112.865C122.71 113.17 123.348 113.347 124.001 113.383C124.653 113.418 125.306 113.313 125.915 113.073C126.524 112.833 127.073 112.465 127.527 111.992L138.779 100.28L143.422 95.4432C146.06 93.3793 147.775 90.3507 148.189 87.0214C148.603 83.6922 147.684 80.3341 145.632 77.6836C143.58 75.033 140.564 73.3063 137.245 72.882C133.925 72.4578 130.573 73.3707 127.924 75.4205L125.022 77.0455L107.986 86.5985C107.099 87.0975 106.403 87.8797 106.01 88.8208C105.617 89.7618 105.549 90.8076 105.818 91.7917Z'),
							$elm$svg$Svg$Attributes$class('fill-accent')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M154.957 97.8293L155.667 120.576L155.671 120.72C155.691 121.375 155.852 122.019 156.143 122.606C156.433 123.194 156.847 123.712 157.356 124.125C157.864 124.537 158.456 124.835 159.089 124.998C159.723 125.161 160.385 125.185 161.028 125.068L164.104 124.511L164.89 124.367H164.894L167.448 123.905L181.045 121.443L183.649 120.973C184.292 120.856 184.902 120.601 185.439 120.226C185.975 119.852 186.425 119.365 186.757 118.801C187.089 118.236 187.296 117.607 187.364 116.955C187.432 116.303 187.36 115.644 187.151 115.023L179.817 93.2536C179.204 89.956 177.312 87.0368 174.555 85.136C171.798 83.2352 168.402 82.5079 165.111 83.1136C161.821 83.7193 158.904 85.6085 157 88.3671C155.097 91.1257 154.362 94.5285 154.957 97.8293Z'),
							$elm$svg$Svg$Attributes$class('fill-accent')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M154.102 30.7288C147.718 35.1097 139.335 39.613 132.814 34.9477C128.532 31.8844 127.183 26.2118 128.919 21.2338C132.042 12.2818 140.621 8.34074 148.824 5.31982C159.489 1.39264 171.101 -1.73162 182.11 1.08084C193.119 3.8933 202.849 14.5798 200.862 25.7944C199.263 34.813 190.778 42.3171 191.983 51.397C193.195 60.5351 203.446 65.3451 212.495 66.9783C221.545 68.6115 231.672 69.1363 238.175 75.6531C246.472 83.9665 244.4 98.8258 236.593 107.603C228.786 116.38 217.006 120.359 205.59 123.064C190.465 126.647 174.107 128.531 159.742 122.583C145.377 116.636 134.199 100.626 138.36 85.614C140.118 79.2728 144.258 73.9136 148.26 68.6963C152.262 63.4789 156.314 58.0231 157.84 51.622C159.112 46.2878 158.171 40.0944 154.642 36.0931C154.001 35.3928 153.597 34.5065 153.489 33.5617C153.381 32.6168 153.574 31.662 154.041 30.8342L154.102 30.7288Z'),
							$elm$svg$Svg$Attributes$fill('#202223')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('clip0_999_1047')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$rect,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$width('243'),
									$elm$svg$Svg$Attributes$height('200'),
									$elm$svg$Svg$Attributes$fill('white'),
									$elm$svg$Svg$Attributes$transform('translate(0.5)')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Page$Agents$AccountAccess$viewEmailSent = F2(
	function (text_, showLink) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(text_)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-8 mb-10 px-7')
						]),
					_List_fromArray(
						[$author$project$Pwr$Ui$Agent$Graphic$viewEmailSent])),
					A2(
					$author$project$Html$Extra$viewIf,
					showLink,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-center')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Events$onClick($author$project$Page$Agents$AccountAccess$ClickedHaventReceivedEmail),
										$elm$html$Html$Attributes$class('btn btn-transparent')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Haven\'t received an email?')
									]))
							])))
				]));
	});
var $author$project$Page$Agents$AccountAccess$BlurredLoginEmail = {$: 13};
var $author$project$Page$Agents$AccountAccess$ClickedRememberMe = {$: 14};
var $author$project$Page$Agents$AccountAccess$ClickedRequestLoginLink = {$: 15};
var $author$project$Page$Agents$AccountAccess$EnteredLoginEmail = function (a) {
	return {$: 12, a: a};
};
var $author$project$Page$Agents$AccountAccess$loginErrorToString = function (error) {
	return 'Invalid email format';
};
var $author$project$Pwr$Ui$Checkbox$viewWithDisabled = F2(
	function (isDisabled, config) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative flex'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opacity-50 cursor-not-allowed', isDisabled)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(config.di),
							$elm$html$Html$Attributes$value(config.dF),
							$elm$html$Html$Attributes$disabled(isDisabled),
							$elm$html$Html$Events$onInput(
							function (_v0) {
								return config.dn;
							}),
							$author$project$Pwr$Test$attribute(config.aD + '-checkbox')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('ml-3 text-sm font-medium text-gray-700'),
						config.dj),
					_List_fromArray(
						[
							$elm$html$Html$text(config.aD)
						]))
				]));
	});
var $author$project$Pwr$Ui$Checkbox$view = function (config) {
	return A2($author$project$Pwr$Ui$Checkbox$viewWithDisabled, false, config);
};
var $author$project$Page$Agents$AccountAccess$viewDontHaveAnAccount = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('text-center pt-6')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Don\'t have an account yet?')
				])),
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick($author$project$Page$Agents$AccountAccess$ClickedRegister),
					$elm$html$Html$Attributes$class('btn btn-transparent')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Register')
				]))
		]));
var $author$project$Page$Agents$AccountAccess$viewRequestMagicLink = function (model) {
	var isFormValid = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return true;
			},
			$elm$core$Result$toMaybe(
				A2($rtfeldman$elm_validate$Validate$validate, $author$project$Page$Agents$AccountAccess$validateLoginEmail, model.C))));
	var fieldError = F2(
		function (errorToFind, field) {
			return A2($erlandsona$assoc_set$AssocSet$member, errorToFind, model.N) ? A2(
				$author$project$Pwr$Ui$Form$error,
				$author$project$Page$Agents$AccountAccess$loginErrorToString(errorToFind),
				field) : field;
		});
	return A3(
		$author$project$Page$Agents$AccountAccess$viewTabPanel,
		model,
		$author$project$Page$Agents$AccountAccess$loginTabId,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center mb-4')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('We know passwords are hard to remember! Instead, request a magic login link that will allow you to login instantly from your email.')
					])),
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Events$onSubmit($author$project$Page$Agents$AccountAccess$ClickedRequestLoginLink),
						$elm$html$Html$Attributes$class('space-y-6')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pwr$Ui$Form$toHtml(
								A2(
									fieldError,
									0,
									A2(
										$author$project$Pwr$Ui$Form$withOnBlur,
										$author$project$Page$Agents$AccountAccess$BlurredLoginEmail,
										A2(
											$author$project$Pwr$Ui$Form$withRequired,
											true,
											A2(
												$author$project$Pwr$Ui$Form$withValue,
												model.C,
												A2(
													$author$project$Pwr$Ui$Form$withLabel,
													'Email',
													A2(
														$author$project$Pwr$Ui$Form$withId,
														'login-email',
														A2(
															$author$project$Pwr$Ui$Form$withStyle,
															1,
															$author$project$Pwr$Ui$Form$emailField($author$project$Page$Agents$AccountAccess$EnteredLoginEmail)))))))))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pwr$Ui$Checkbox$view(
								{
									di: model.W,
									aD: 'Remember me on this device for 30 days',
									dj: _List_Nil,
									dn: $author$project$Page$Agents$AccountAccess$ClickedRememberMe,
									dF: model.W ? 'true' : 'false'
								})
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-center')
							]),
						_List_fromArray(
							[
								$author$project$Pwr$Ui$ButtonWithSpinner$view(
								{
									aM: _List_fromArray(
										[
											_Utils_Tuple2('btn btn-primary py-3 rounded-lg text-lg', true)
										]),
									aP: !isFormValid,
									aU: model.v,
									aD: 'Request magic login link',
									ba: $author$project$Pwr$Ui$ButtonWithSpinner$Submit,
									bd: 'w-full'
								})
							]))
					])),
				A2(
				$author$project$Html$Extra$viewIf,
				!$author$project$Pwr$Tenant$communityClosed(model.o),
				$author$project$Page$Agents$AccountAccess$viewDontHaveAnAccount)
			]));
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Page$Agents$AccountAccess$viewWithTitle = F3(
	function (model, title, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative flex flex-col px-4 xs:px-8 pt-6 pb-10')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-center')
						]),
					_List_fromArray(
						[
							$author$project$Pwr$Ui$Branding$Graphic$viewLogo(model.o)
						])),
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-2xl font-medium font-sans text-center my-6')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					content
				]));
	});
var $author$project$Page$Agents$AccountAccess$viewPage = function (model) {
	var _v0 = $author$project$SelectList$selected(model.f);
	switch (_v0) {
		case 0:
			return A3(
				$author$project$Page$Agents$AccountAccess$viewWithTitle,
				model,
				$author$project$Page$Agents$AccountAccess$createAccountTitle(model.o),
				$author$project$Page$Agents$AccountAccess$viewCreate(model));
		case 1:
			return A3(
				$author$project$Page$Agents$AccountAccess$viewWithTitle,
				model,
				'You\'re almost there',
				A2($author$project$Page$Agents$AccountAccess$viewEmailSent, 'We\'ve sent an email to the address you provided. Check your inbox to verify your account!', true));
		case 2:
			return A3(
				$author$project$Page$Agents$AccountAccess$viewWithTitle,
				model,
				'Login link sent',
				A2($author$project$Page$Agents$AccountAccess$viewEmailSent, 'A magic login link has been sent to the email you provided. The link expires in 15 minutes, so be sure to open it right away!', false));
		case 3:
			return A3(
				$author$project$Page$Agents$AccountAccess$viewWithTitle,
				model,
				'Haven\'t received an email yet?',
				$author$project$Page$Agents$AccountAccess$viewEmailMissing(model));
		default:
			return A3(
				$author$project$Page$Agents$AccountAccess$viewWithTitle,
				model,
				'Login to your Account',
				$author$project$Page$Agents$AccountAccess$viewRequestMagicLink(model));
	}
};
var $author$project$Pwr$Ui$Agent$Onboarding$Layout$withAttr = F2(
	function (attr, config) {
		return _Utils_update(
			config,
			{
				aA: $elm$core$Maybe$Just(attr)
			});
	});
var $author$project$Pwr$Ui$Agent$Onboarding$Layout$withOverlay = F2(
	function (showOverlay, config) {
		return _Utils_update(
			config,
			{S: showOverlay});
	});
var $author$project$Page$Agents$AccountAccess$view = function (model) {
	return A2(
		$author$project$Pwr$Ui$Agent$Onboarding$Layout$view,
		$author$project$Page$Agents$AccountAccess$viewPage(model),
		A2(
			$author$project$Pwr$Ui$Agent$Onboarding$Layout$withAttr,
			$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('min-h-screen md:min-h-[50vh] md:w-[600px]', true)
					])),
			A2(
				$author$project$Pwr$Ui$Agent$Onboarding$Layout$withOverlay,
				true,
				$author$project$Pwr$Ui$Agent$Onboarding$Layout$init(model.o))));
};
var $author$project$Page$Agents$New$main = $author$project$Page$program(
	{
		db: $author$project$Page$Agents$New$flagsDecoder,
		bV: $author$project$Page$Agents$New$init,
		cN: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		cR: $author$project$Page$Agents$AccountAccess$update,
		cV: $author$project$Page$Agents$AccountAccess$view
	});
/*
_Platform_export({'Page':{'Agents':{'New':{'init':$author$project$Page$Agents$New$main($elm$json$Json$Decode$value)(0)}}}});}(this));
*/
export const Elm = {'Page':{'Agents':{'New':{'init':$author$project$Page$Agents$New$main($elm$json$Json$Decode$value)(0)}}}};
  